"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9457],{

/***/ 99554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_input; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/InputContainer/input-container.styles.js
var input_container_styles = __webpack_require__(66457);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/filter-input.styles.js




const Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  border: solid 1px ${props => (0,build_esm/* getTextColor */.uu)('lighter')(props)};
  border-radius: 2px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/index.js + 2 modules
var HiddenLabel = __webpack_require__(33055);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/filter-input.js







const FilterInput = _ref => {
  let {
    onChange,
    onClearInput,
    label
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onChange", "onClearInput", "label"]);

  const [value, setValue] = (0,react.useState)('');

  const handleOnChange = e => {
    setValue(e.target.value);
    onChange(e);
  };

  const handleClearInput = e => {
    setValue('');
    onClearInput(e);
  };

  return /*#__PURE__*/react.createElement(Wrapper, props, /*#__PURE__*/react.createElement(input_container_styles/* ContainerInput */.xJ, null, /*#__PURE__*/react.createElement(esm/* Search */.olm, {
    color: "#818181",
    "data-testid": "icon-search"
  }), /*#__PURE__*/react.createElement("form", null, /*#__PURE__*/react.createElement(HiddenLabel/* default */.Z, {
    text: "pesquisar por filtro",
    htmlFor: "search-filter"
  }), /*#__PURE__*/react.createElement(input_container_styles/* Input */.II, {
    id: `search-filter ${label}`,
    value: value,
    onChange: handleOnChange,
    placeholder: `Busque por ${label}`
  })), value && /*#__PURE__*/react.createElement(esm/* CloseCircleFilled */.B86, {
    color: "#818181",
    onClick: handleClearInput,
    title: "Limpar texto"
  })));
};

FilterInput.defaultProps = {
  onChange: () => ({}),
  onClearInput: () => ({}),
  label: ''
};
 false ? 0 : void 0;
/* harmony default export */ var filter_input = (FilterInput);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/index.js


/***/ }),

/***/ 1729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_item; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterItem/filter-item.styles.js


const Container = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)({
  gridTemplateColumns: 'auto 1fr',
  alignItems: 'center',
  padding: '6px 12px'
});
const IconContainer = styled_components_browser_esm/* default.div */.ZP.div`
  margin-right: 7px;
`;
const Button = styled_components_browser_esm/* default.button */.ZP.button`
  background-color: transparent;
  cursor: pointer;
  border: none;
  text-decoration: none;
`;
const ItemContainer = styled_components_browser_esm/* default.div */.ZP.div``;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterItem/filter-item.js






const FilterItem = ({
  item,
  onClick,
  children
}) => {
  const {
    label,
    selected
  } = item;
  const [checked, setChecked] = (0,react.useState)(selected);
  (0,react.useEffect)(() => {
    setChecked(selected);
    return () => {
      setChecked(false);
    };
  }, [selected]);
  return /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(Button, {
    onClick: e => onClick(e, item),
    "aria-label": `Filtrar por ${item.name}`,
    "data-testid": "filter-item"
  }, /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(IconContainer, {
    role: "checkbox",
    "aria-checked": selected,
    "aria-labelledby": label
  }, checked ? /*#__PURE__*/react.createElement(esm/* BoxChecked */.nvx, {
    "aria-hidden": "true"
  }) : /*#__PURE__*/react.createElement(esm/* BoxUnchecked */.XE8, {
    "aria-hidden": "true"
  })), /*#__PURE__*/react.createElement(ItemContainer, {
    children: children || /*#__PURE__*/react.createElement(Text/* default */.Z, {
      fontSize: 1,
      id: label
    }, label)
  }))));
};

 false ? 0 : void 0;
FilterItem.defaultProps = {
  item: {
    selected: false
  },
  children: null,
  onClick: () => ({})
};
/* harmony default export */ var filter_item = (FilterItem);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterItem/index.js


/***/ }),

/***/ 33055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ hidden_label; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/hidden-label.styles.js

const Label = styled_components_browser_esm/* default.label */.ZP.label`
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/hidden-label.js





const HiddenLabel = _ref => {
  let {
    text
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["text"]);

  return /*#__PURE__*/react.createElement(Label, props, text);
};

HiddenLabel.defaultProps = {
  text: ''
};
 false ? 0 : void 0;
/* harmony default export */ var hidden_label = (HiddenLabel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/index.js


/***/ }),

/***/ 2490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HotLinks_HotLinks; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HotLinks/HotLinks.styles.js



const directionRowStyle = styled_components_browser_esm/* css */.iv`
  overflow-y: hidden;

  > *:not(:first-child) {
    margin-left: 8px;
  }
`;
const directionColumnStyle = styled_components_browser_esm/* css */.iv`
  overflow-x: hidden;

  > *:not(:first-child) {
    margin-top: 8px;
  }
`;

const addDirectionStyle = ({
  directionType
}) => directionType === 'row' ? directionRowStyle : directionColumnStyle;

const LinksContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(({
  directionType
}) => ({
  pb: '1em',
  flexDirection: directionType
}))`
  ${({
  directionType
}) => directionType === 'column' && `
      padding: 1em;
  `}

  ${addDirectionStyle};
`;
const ShowMore = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  text-decoration: underline;
  cursor: pointer;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HotLink/index.js + 2 modules
var HotLink = __webpack_require__(39471);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HotLinks/HotLinks.js





const HotLinks = ({
  items,
  onItemClick,
  directionType,
  limitItems
}) => {
  const [itemsToShow, setItemsToShow] = (0,react.useState)(limitItems);
  const totalItems = items.length;
  const showMore = !!limitItems && itemsToShow < totalItems;
  const visibleItems = (0,react.useMemo)(() => {
    return !limitItems ? items : items.slice(0, itemsToShow);
  }, [limitItems, items, itemsToShow]);

  const renderItems = () => visibleItems.map((item, index) => /*#__PURE__*/react.createElement(HotLink/* default */.Z, {
    key: index,
    item: item,
    onClick: onItemClick,
    directionType: directionType,
    borderColor: item.borderColor
  }));

  return /*#__PURE__*/react.createElement(LinksContent, {
    "data-testid": "hot-links",
    directionType: directionType
  }, renderItems(), showMore && /*#__PURE__*/react.createElement(ShowMore, {
    onClick: () => setItemsToShow(totalItems),
    "data-testid": "show-more",
    role: "button"
  }, "Ver mais"));
};

HotLinks.defaultProps = {
  items: [],
  directionType: 'row',
  limitItems: null,
  onItemClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var HotLinks_HotLinks = (HotLinks);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HotLinks/index.js


/***/ }),

/***/ 15309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ icon_button; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/IconButton/icon-button.styles.js

const Container = styled_components_browser_esm/* default.div */.ZP.div`
  border: 0;
  background: transparent;
  display: flex;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/IconButton/icon-button.js




function handleClick(e, onClick) {
  onClick(e);
}

function IconButton({
  onClick,
  children
}) {
  return /*#__PURE__*/react.createElement(Container, {
    onClick: e => handleClick(e, onClick)
  }, children);
}

 false ? 0 : void 0;
/* harmony default export */ var icon_button = (IconButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/IconButton/index.js


/***/ }),

/***/ 97769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ installment; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Installment/installment.styles.js




const Content = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(({
  isList
}) => ({
  fontSize: [isList ? 0 : 1, 1],
  fontWeight: 'regular',
  lineHeight: ['fontSize', 'display']
}))`
  ${index_esm/* typography */.cp}
  margin-bottom: ${() => (0,build_esm/* themeGet */.R)('space.2')}px;
`;
const SrOnlyText = styled_components_browser_esm/* default.span */.ZP.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Installment/installment.js







const Installment = _ref => {
  let {
    information,
    isList,
    minimumInstallment,
    format
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["information", "isList", "minimumInstallment", "format"]);

  const {
    quantity,
    amount,
    paymentMethodDescription,
    totalAmount
  } = information;
  const formattedAmount = (0,esm/* currencyFormatter */.oB)({
    value: amount
  });
  const formattedTotalAmount = (0,esm/* currencyFormatter */.oB)({
    value: totalAmount
  });
  const shouldShowFullFormat = quantity > 1 && !isList;
  const shortFormat = `${quantity}x de ${formattedAmount} ${paymentMethodDescription}`;
  const fullFormat = `${formattedTotalAmount} em ${quantity}x de ${formattedAmount} ${paymentMethodDescription}`;
  const shortFormatAccessible = `${quantity} vez de ${formattedAmount} ${paymentMethodDescription}`;
  const fullFormatAccessible = `${totalAmount} em ${quantity} vezes de ${formattedAmount} ${paymentMethodDescription}`;
  const isFull = format === 'full' || format !== 'short' && shouldShowFullFormat;
  const content = isFull ? fullFormat : shortFormat;
  const contentAcessible = isFull ? fullFormatAccessible : shortFormatAccessible;

  if (minimumInstallment === 0) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Content, (0,esm_extends/* default */.Z)({
      isList: isList,
      "data-testid": "installment",
      "aria-hidden": "true"
    }, props), content), /*#__PURE__*/react.createElement(SrOnlyText, null, contentAcessible));
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Content, (0,esm_extends/* default */.Z)({
    isList: isList,
    "data-testid": "installment",
    "aria-hidden": "true"
  }, props), fullFormat), /*#__PURE__*/react.createElement(SrOnlyText, null, fullFormatAccessible));
};

 false ? 0 : void 0;
Installment.defaultProps = {
  information: {
    amount: '',
    isList: false,
    format: '',
    paymentMethodDescription: '',
    quantity: '',
    totalAmount: ''
  },
  minimumInstallment: 1
};
/* harmony default export */ var installment = (Installment);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Installment/index.js


/***/ }),

/***/ 78012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/filterHandlers.js
/**
 * @param  {} dataSource
 * @param  {} searchTerm
 * @param  {} searchProperty
 */
const filterHandler = (dataSource, searchTerm, searchProperty) => {
  if (Array.isArray(dataSource) && typeof searchProperty === 'string' && searchProperty) return dataSource == null ? void 0 : dataSource.filter(item => {
    var _item$searchProperty, _item$searchProperty$;

    return (_item$searchProperty = item[searchProperty]) == null ? void 0 : (_item$searchProperty$ = _item$searchProperty.toUpperCase()) == null ? void 0 : _item$searchProperty$.includes(searchTerm.toUpperCase());
  });
  return dataSource;
};
/**
 * @param  {} dataSource
 * @param  {} sortBy
 */


const sortByHandler = (dataSource, sortBy) => {
  return sortBy instanceof Function ? dataSource == null ? void 0 : dataSource.sort(sortBy) : dataSource;
};
/**
 * @param  {} {searchTerm
 * @param  {} dataSource
 * @param  {} sortBy
 * @param  {} searchProperty}
 *
 * Build list items with dataSource
 */


/* harmony default export */ var filterHandlers = (({
  searchTerm,
  dataSource,
  sortBy,
  searchProperty
}) => sortByHandler(filterHandler(dataSource, searchTerm, searchProperty), sortBy));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list-context.js



const Context = /*#__PURE__*/(0,react.createContext)(false);

const ListContext = _ref => {
  let {
    children,
    value: {
      disableGutters
    }
  } = _ref,
      values = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref.value, ["disableGutters"]);

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: Object.assign({
      basis: disableGutters ? 32 : 40,
      gutters: disableGutters ? 0 : 3
    }, values)
  }, children);
};

const useListContext = () => (0,react.useContext)(Context);
 false ? 0 : void 0;
/* harmony default export */ var list_context = (ListContext);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/index.js + 5 modules
var Item = __webpack_require__(81572);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/index.js + 2 modules
var Collapse = __webpack_require__(88699);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list.styles.js







const buildBorderWidth = ({
  gutters,
  basis = 0,
  inset = 0,
  props
}) => {
  return (0,esm/* themeGet */.R)(`space.${gutters}`)(props) + parseInt(basis, 10) * Number(inset);
};

const buildHorizontalList = ({
  horizontal
}) => horizontal && styled_components_browser_esm/* css */.iv`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(30px, max-content));
    justify-content: space-between;
  `;

const buildBorder = styled_components_browser_esm/* css */.iv`
  > *:not(:last-child) {
    border-bottom: ${(0,esm/* themeGet */.R)('borders.0')};
  }
`;
const ItemWrapper = styled_components_browser_esm/* default.li */.ZP.li({
  listStyle: 'none',
  position: 'relative'
});
const list_styles_Item = (0,styled_components_browser_esm/* default */.ZP)(Item/* default */.Z).attrs(_ref => {
  let {
    inset,
    basis,
    gutters,
    content,
    horizontal
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["inset", "basis", "gutters", "content", "horizontal"]);

  return Object.assign({
    position: 'relative',
    gap: 0,
    rowGap: 2,
    px: 0,
    py: content ? 2 : 0,
    pl: inset ? buildBorderWidth({
      gutters,
      basis,
      inset,
      props
    }) : buildBorderWidth({
      gutters,
      props
    }),
    pr: buildBorderWidth({
      gutters,
      props
    })
  }, horizontal && {
    textAlign: 'center',
    pl: 0,
    pr: 0
  }, props);
})`
  cursor: pointer;
  ${({
  selectable
}) => selectable && styled_components_browser_esm/* css */.iv`
      &:hover {
        background: ${(0,esm/* getBackgroundColor */.dF)('darker')};
      }
    `};

  ${({
  horizontal
}) => horizontal && styled_components_browser_esm/* css */.iv`
      > span {
        position: unset;
        transform: unset;
        left: 0;
      }
    `}

  ${({
  divided,
  isCollapsed
}) => divided && !isCollapsed && styled_components_browser_esm/* css */.iv`
      border-top: ${(0,esm/* themeGet */.R)('borders.0')};
    `}
`;
const ListDefault = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj)`
  ${({
  divided
}) => divided && buildBorder}
  ${buildHorizontalList}
`;
const ListCollapse = (0,styled_components_browser_esm/* default */.ZP)(Collapse/* default */.Z)`
  ${({
  divided
}) => divided && buildBorder}
  ${buildHorizontalList}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list-action.js







const ListAction = _ref => {
  let {
    as,
    children,
    color,
    fill,
    startIcon,
    endIcon,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "children", "color", "fill", "startIcon", "endIcon", "onClick"]);

  const {
    variant,
    divided,
    scale,
    gutters,
    isCollapsed
  } = useListContext();
  return /*#__PURE__*/react.createElement(list_styles_Item, (0,esm_extends/* default */.Z)({
    forwardedAs: as,
    variant: variant,
    startIcon: startIcon,
    endIcon: endIcon,
    gutters: gutters,
    scale: scale,
    color: color,
    fill: fill,
    divided: divided,
    isCollapsed: isCollapsed,
    onClick: onClick,
    "data-testid": "list-action"
  }, props), children);
};

 false ? 0 : void 0;
ListAction.defaultProps = {
  as: 'div',
  centered: false,
  children: null,
  fontWeight: 'medium',
  gap: 1
};
ListAction.displayName = 'ListAction';
/* harmony default export */ var list_action = (ListAction);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/withWrapper.js







const withWrapper = Component => {
  const wrapper = _ref => {
    let {
      as: childType
    } = _ref,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as"]);

    const {
      type: parentType
    } = useListContext();

    if (['ul', 'ol'].includes(parentType) && childType === 'a') {
      return /*#__PURE__*/react.createElement(ItemWrapper, null, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
        as: childType
      }, props)));
    }

    return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
      as: ['ul', 'ol'].includes(parentType) ? 'li' : 'div'
    }, props));
  };

   false ? 0 : void 0;
  wrapper.defaultProps = {
    as: ''
  };
  return wrapper;
};

/* harmony default export */ var List_withWrapper = (withWrapper);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list-checkbox.js










const ListCheckbox = _ref => {
  let {
    as,
    checked,
    children,
    content,
    defaultChecked,
    description,
    endIcon,
    fill,
    value,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "checked", "children", "content", "defaultChecked", "description", "endIcon", "fill", "value", "onClick"]);

  const [isChecked, setIsChecked] = (0,react.useState)(checked);
  const {
    variant,
    scale,
    basis,
    gutters,
    selectable
  } = useListContext();

  const handleOnClick = e => {
    setIsChecked(!isChecked);
    onClick(e);
  };

  (0,react.useEffect)(() => {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/react.createElement(list_styles_Item, (0,esm_extends/* default */.Z)({
    forwardedAs: as,
    variant: variant,
    startIcon: /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      width: basis
    }, /*#__PURE__*/react.createElement(Checkbox/* default */.Z, {
      checked: isChecked,
      defaultChecked: defaultChecked,
      value: value
    })),
    endIcon: endIcon,
    description: description,
    content: content,
    selectable: selectable,
    scale: scale,
    gutters: gutters,
    fill: fill,
    onClick: handleOnClick,
    "data-testid": "list-checkbox"
  }, props), children);
};

 false ? 0 : void 0;
ListCheckbox.defaultProps = {
  checked: false,
  children: null,
  endIcon: '',
  fill: 'currentColor',
  onClick: () => {}
};
/* harmony default export */ var list_checkbox = (List_withWrapper(ListCheckbox));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list-header.js








const ListHeader = _ref => {
  let {
    as,
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "children", "onClick"]);

  const {
    variant,
    scale,
    gutters
  } = useListContext();
  return /*#__PURE__*/react.createElement(list_styles_Item, (0,esm_extends/* default */.Z)({
    forwardedAs: as,
    variant: variant,
    scale: scale,
    gutters: gutters,
    "data-testid": "list-header"
  }, props), children);
};

 false ? 0 : void 0;
ListHeader.defaultProps = {
  children: null,
  fontSize: 2,
  fontWeight: 'medium'
};
ListHeader.displayName = 'ListHeader';
/* harmony default export */ var list_header = (List_withWrapper(ListHeader));
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list-item.js










const ListItem = _ref => {
  let {
    as,
    children,
    content,
    description,
    endIcon,
    fill,
    inset,
    onClick,
    startIcon
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "children", "content", "description", "endIcon", "fill", "inset", "onClick", "startIcon"]);

  const {
    variant,
    basis,
    scale,
    gutters,
    selectable,
    horizontal
  } = useListContext();
  return /*#__PURE__*/react.createElement(list_styles_Item, (0,esm_extends/* default */.Z)({
    forwardedAs: as,
    variant: variant,
    startIcon: startIcon && !inset && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      width: basis
    }, typeof startIcon === 'string' ? /*#__PURE__*/react.createElement(build_esm/* Icon */.JO$, {
      name: startIcon,
      color: fill,
      fill: fill
    }) : startIcon),
    endIcon: endIcon && (typeof endIcon === 'string' ? /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      width: basis,
      justifyContent: "flex-end"
    }, /*#__PURE__*/react.createElement(build_esm/* Icon */.JO$, {
      name: endIcon,
      color: fill,
      fill: fill
    })) : endIcon),
    description: description,
    content: content,
    selectable: selectable,
    gutters: gutters,
    basis: basis,
    inset: inset,
    scale: scale,
    fill: fill,
    horizontal: horizontal,
    onClick: onClick,
    "data-testid": "list-item"
  }, props), children);
};

 false ? 0 : void 0;
ListItem.defaultProps = {
  children: null,
  endIcon: '',
  fill: 'currentColor',
  inset: false,
  startIcon: ''
};
ListItem.displayName = 'ListItem';
/* harmony default export */ var list_item = (List_withWrapper(ListItem));
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/index.js + 2 modules
var Radio = __webpack_require__(70715);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list-radio.js










const ListRadio = _ref => {
  let {
    as,
    children,
    href,
    label,
    value,
    selected,
    description,
    endIcon,
    fill,
    onChange,
    position,
    eventLabel,
    filterLabel
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "children", "href", "label", "value", "selected", "description", "endIcon", "fill", "selectedOption", "onChange", "position", "eventLabel", "filterLabel"]);

  const {
    name,
    variant,
    basis,
    scale,
    gutters,
    selectable
  } = useListContext();

  const handleOnChange = e => {
    e.preventDefault();
    const filter = {
      label: eventLabel,
      href,
      value,
      selected,
      filterLabel,
      position
    };
    onChange(e, filter);
  };

  return /*#__PURE__*/react.createElement(list_styles_Item, (0,esm_extends/* default */.Z)({
    forwardedAs: as,
    variant: variant,
    onClick: handleOnChange,
    startIcon: /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      width: basis
    }, /*#__PURE__*/react.createElement(Radio/* default */.Z, {
      readOnly: true,
      name: name,
      label: label,
      checked: selected,
      value: value,
      width: 1
    })),
    endIcon: endIcon,
    description: description,
    selectable: selectable,
    scale: scale,
    gutters: gutters,
    fill: fill,
    "data-testid": "list-radio-group",
    href: href
  }, props), children);
};

 false ? 0 : void 0;
ListRadio.defaultProps = {
  checked: false,
  children: null,
  endIcon: '',
  fill: 'currentColor',
  onChange: () => {}
};
/* harmony default export */ var list_radio = (List_withWrapper(ListRadio));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/list.js













const RenderItems = ({
  children,
  dataSource,
  renderItem,
  searchProperty,
  searchTerm,
  sortBy
}) => {
  const filteredData = (0,react.useMemo)(() => filterHandlers({
    dataSource,
    searchProperty,
    searchTerm,
    sortBy
  }), [dataSource, searchTerm]);
  return Array.isArray(filteredData) && renderItem instanceof Function ? filteredData == null ? void 0 : filteredData.map((item, index) => renderItem(Object.assign({
    key: index
  }, item))) : children;
};

const List = _ref => {
  let {
    as: type,
    children,
    dataSource,
    disableGutters,
    horizontal,
    divided,
    name,
    renderItem,
    scale,
    searchProperty,
    searchTerm,
    selectable,
    sortBy,
    variant,
    renderAction,
    trigger,
    collapsedIn,
    collapse
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "children", "dataSource", "disableGutters", "horizontal", "divided", "name", "renderItem", "scale", "searchProperty", "searchTerm", "selectable", "sortBy", "variant", "renderAction", "trigger", "collapsedIn", "collapse"]);

  const Container = collapse ? ListCollapse : ListDefault;
  const [data, setData] = (0,react.useState)(dataSource);
  const [term, setTerm] = (0,react.useState)(searchTerm);
  (0,react.useEffect)(() => {
    setTerm(searchTerm);
  }, [searchTerm]);
  (0,react.useEffect)(() => {
    setData(dataSource);
  }, [JSON.stringify(dataSource)]);
  return /*#__PURE__*/react.createElement(list_context, {
    value: {
      divided,
      disableGutters,
      horizontal,
      name,
      selectable,
      scale,
      variant,
      type,
      isCollapsed: trigger
    }
  }, /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    forwardedAs: type,
    divided: divided,
    trigger: trigger,
    collapsedIn: collapsedIn,
    horizontal: horizontal,
    "data-testid": "list"
  }, props), /*#__PURE__*/react.createElement(RenderItems, {
    searchTerm: term,
    dataSource: data,
    sortBy: sortBy,
    searchProperty: searchProperty,
    renderItem: renderItem,
    children: children
  })), renderAction);
};

 false ? 0 : void 0;
List.defaultProps = {
  as: 'ul',
  children: null,
  dataSource: [],
  disableGutters: false,
  divided: false,
  scale: 'medium',
  searchProperty: '',
  searchTerm: '',
  selectable: false,
  variant: 'transparent',
  horizontal: false
};

List.Collapse = props => /*#__PURE__*/react.createElement(List, (0,esm_extends/* default */.Z)({
  collapse: true
}, props));

List.Header = list_header;
List.Item = list_item;
List.Action = list_action;
List.Checkbox = list_checkbox;
List.Radio = list_radio;
List.Collapse.displayName = 'ListCollapse';
/* harmony default export */ var list = (List);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js


/***/ }),

/***/ 33359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ list_display_type; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListDisplayType/list-display-type.styles.js


const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  cursor: pointer;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListDisplayType/list-display-type.js




const options = [{
  id: 'gallery',
  label: 'Galeria',
  icon: /*#__PURE__*/react.createElement(esm/* ViewModule */.qiR, {
    height: "20",
    color: "#818181"
  })
}, {
  id: 'list',
  label: 'Lista',
  icon: /*#__PURE__*/react.createElement(esm/* Burger */.OWX, {
    height: "18",
    color: "#818181"
  })
}, {
  id: 'miniature',
  label: 'Miniatura',
  icon: /*#__PURE__*/react.createElement(esm/* FeaturedVideo */.DxU, {
    height: "16",
    color: "#818181"
  })
}];

function ListDisplayType({
  onChange,
  defaultMode
}) {
  const [option, setOption] = (0,react.useState)(options.find(o => o.id === defaultMode));
  const [index, setIndex] = (0,react.useState)(options.findIndex(o => o.id === defaultMode) + 1);

  function rotateIndex(idx) {
    if (idx >= options.length - 1) {
      setIndex(0);
      return;
    }

    const num = idx + 1;
    setIndex(num);
  }

  function handleClick() {
    rotateIndex(index);
    setOption(options[index]);
    const selectedOption = Object.assign({}, options[index]);
    delete selectedOption.icon;
    onChange(selectedOption);
  }

  (0,react.useEffect)(() => {
    if (option.id !== defaultMode) {
      const displayIndex = options.findIndex(o => o.id === defaultMode);
      setIndex(displayIndex + 1);
      setOption(options[displayIndex]);
      const selectedDisplay = Object.assign({}, options[displayIndex]);
      onChange(selectedDisplay);
    }
  }, [defaultMode]);
  return /*#__PURE__*/react.createElement(Container, {
    onClick: handleClick,
    p: 1,
    "data-testid": "display-type"
  }, option.label, " ", option.icon);
}

ListDisplayType.defaultProps = {
  defaultMode: 'gallery'
};
 false ? 0 : void 0;
/* harmony default export */ var list_display_type = (ListDisplayType);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListDisplayType/index.js


/***/ }),

/***/ 41065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ list_suggestion_item; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/list-suggestions-item.style.js




const Container = styled_components_browser_esm/* default.li */.ZP.li`
  display: flex;
  align-items: center;
  padding: ${props => (0,build_esm/* themeGet */.R)(`space.${props.desktopMode ? 1 : 2}`)(props)}px;
  ${props => props.desktopMode && styled_components_browser_esm/* css */.iv`
      cursor: pointer;
      ${({
  borderBottom
}) => borderBottom && styled_components_browser_esm/* css */.iv`
          border-bottom: 1px solid #e5e5e5;
        `}

      :hover {
        background-color: #dcebf4;
      }
    `}
`;
const ContainerText = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  padding-left: ${props => (0,build_esm/* themeGet */.R)('space.1')(props)}px;
  font-size: ${props => (0,build_esm/* themeGet */.R)(`fontSizes.${props.desktopMode ? 0 : 2}`)(props)}px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
`;
const ContainerTextPrice = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  padding-left: ${props => (0,build_esm/* themeGet */.R)('space.1')(props)}px;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('primary')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  text-align: initial;
`;
const ProductImage = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)``;
const ProductImageContainer = styled_components_browser_esm/* default.div */.ZP.div`
  width: 59px;
  height: 44px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/helpers/highlightPartOfString.js


const highlightPartOfString = (query, suggestionListTerms, i) => {
  var _query$toLowerCase;

  const sanitizedTerm = query == null ? void 0 : (_query$toLowerCase = query.toLowerCase()) == null ? void 0 : _query$toLowerCase.trim();
  const termIndex = suggestionListTerms.toLowerCase().indexOf(sanitizedTerm);

  if (termIndex === 0) {
    return /*#__PURE__*/react.createElement("span", {
      key: i
    }, sanitizedTerm, /*#__PURE__*/react.createElement("strong", null, suggestionListTerms.substring(termIndex + sanitizedTerm.length, suggestionListTerms.length)));
  }

  return /*#__PURE__*/react.createElement("span", {
    key: i
  }, /*#__PURE__*/react.createElement("strong", null, suggestionListTerms.substring(0, termIndex)), sanitizedTerm, /*#__PURE__*/react.createElement("strong", null, suggestionListTerms.substring(termIndex + sanitizedTerm.length, suggestionListTerms.length)));
};

/* harmony default export */ var helpers_highlightPartOfString = (highlightPartOfString);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/helpers/buildHighlightedQuery.js



const buildHighlightedQuery = ({
  query,
  suggestionItem
}) => {
  // verifica se a query é igual a sugestão, caso seja a palavra retorna sem nenhuma alteração
  if (query === suggestionItem.term) {
    return query;
  } // separa palavra por palavra, assim podendo realizar a verificação


  const queryTerms = query.split(' ');
  const suggestionItemTerms = suggestionItem.term.split(' ');
  return suggestionItemTerms // filter para verificar que não é uma string vazia
  .filter(suggestionTerms => Boolean(suggestionTerms)).map((suggestionTerms, i) => {
    // o find verifica se a pesquisa feita pelo usuário existe na lista de sugestão
    const presentQueryTerm = queryTerms.find(queryT => suggestionTerms.toLowerCase().includes(queryT.toLowerCase())); // caso não existe retorna a palavra em negrito

    if (!presentQueryTerm) {
      return /*#__PURE__*/react.createElement("strong", {
        key: i.toString()
      }, suggestionTerms);
    } // caso existe verifica se é a palavra inteira


    if (presentQueryTerm === suggestionTerms) {
      return suggestionTerms;
    } // caso exista e não seja a palavra inteira vai para o verificador de parte da string


    return helpers_highlightPartOfString(presentQueryTerm, suggestionTerms, i);
  }).reduce((prev, curr) => [prev, ' ', curr]);
};

/* harmony default export */ var helpers_buildHighlightedQuery = (buildHighlightedQuery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/helpers/index.js


;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/list-suggestion-item.js








const ListSuggestionItem = _ref => {
  let {
    item,
    term,
    desktopMode,
    onSearchSubmit
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["item", "term", "desktopMode", "onSearchSubmit"]);

  const [query, setQuery] = (0,react.useState)(term);
  (0,react.useEffect)(() => {
    setQuery(term);
  }, [term]);
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "suggestion-item",
    key: item.count || item.id,
    onClick: onSearchSubmit,
    desktopMode: desktopMode
  }, props), item.img && /*#__PURE__*/react.createElement(ProductImageContainer, null, /*#__PURE__*/react.createElement(ProductImage, {
    src: item.img
  })), props.prefix && !item.img ? props.prefix : /*#__PURE__*/react.createElement(react.Fragment, null), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ContainerText, (0,esm_extends/* default */.Z)({
    "data-testid": "suggestion-text",
    desktopMode: desktopMode
  }, props), helpers_buildHighlightedQuery({
    query,
    suggestionItem: item
  }), desktopMode && item.count ? ` (${item.count})` : ''), item.price && /*#__PURE__*/react.createElement(ContainerTextPrice, {
    "data-testid": "suggestion-price"
  }, (0,esm/* currencyFormatter */.oB)({
    value: item.price
  }))));
};

/* harmony default export */ var list_suggestion_item = (ListSuggestionItem);
 false ? 0 : void 0;
ListSuggestionItem.defaultProps = {
  item: {},
  desktopMode: false,
  borderBottom: false,
  onSearchSubmit: null
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/index.js


/***/ }),

/***/ 97949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ media_review_card; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/media-review-card.styles.js


const MediaReviewCardComponent = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).attrs(props => Object.assign({}, props))`
  width: ${props => props.width || '90px'};
  height: ${props => props.height || '90px'};
  background: url(${props => props.mediaUrl}) no-repeat center lightgray;
  background-size: cover;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/media-review-card.js







const MediaReviewCard = _ref => {
  let {
    children,
    media,
    onClick,
    width,
    height
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "media", "onClick", "width", "height"]);

  const {
    mediaType,
    mediaUrl
  } = media;
  return /*#__PURE__*/react.createElement(MediaReviewCardComponent, (0,esm_extends/* default */.Z)({
    "data-testid": `media-card-${mediaUrl}`,
    mediaUrl: mediaUrl,
    onClick: onClick,
    width: width,
    height: height
  }, props), mediaType === 'video' && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "VideoCircle",
    width: "40px",
    height: "40px"
  }), children);
};

 false ? 0 : void 0;
/* harmony default export */ var media_review_card = (MediaReviewCard);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/index.js


/***/ }),

/***/ 48919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ menu_content; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuFooter/menu-footer.styles.js





const FooterMenuWrapper = styled_components_browser_esm/* default.nav */.ZP.nav`
  background-color: ${props => (0,esm/* getBackgroundColor */.dF)('white')(props)};
  width: fit-content;
  padding: 20px;
`;
const FooterList = styled_components_browser_esm/* default.ul */.ZP.ul`
  list-style: none;
  display: flex;
`;
const FooterItem = styled_components_browser_esm/* default.li.attrs */.ZP.li.attrs(() => ({
  mr: 3
}))`
  display: flex;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  width: max-content;

  ${index_esm/* space */.Dh}
`;
const menu_footer_styles_Link = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z)``;
const ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  color: 'text.primary',
  m: 0
}, props))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuFooter/menu-footer.js




const MenuFooter = ({
  data,
  onMenuFooterClick
}) => {
  const {
    linksList
  } = data;
  return /*#__PURE__*/react.createElement(FooterMenuWrapper, {
    "data-testid": "header-menu-footer-elem"
  }, linksList ? /*#__PURE__*/react.createElement(FooterList, null, linksList.map((link, index) => /*#__PURE__*/react.createElement(FooterItem, {
    key: `footer-item-${index}`
  }, link.img && link.img.component && /*#__PURE__*/react.createElement(ImageWrapper, {
    "data-testid": "image-elem",
    width: link.img.width
  }, link.img.component), /*#__PURE__*/react.createElement(menu_footer_styles_Link, {
    onClick: e => onMenuFooterClick(e, link),
    href: link.url,
    px: 2
  }, link.label)))) : /*#__PURE__*/react.createElement(react.Fragment, null));
};

MenuFooter.defaultProps = {
  data: {},
  onMenuFooterClick: () => ({})
};
 false ? 0 : void 0;
/* harmony default export */ var menu_footer = (MenuFooter);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuFooter/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuContent/menu-content.styles.js




const MenuBox = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  bg: 'background.white'
}, props))`
  border-bottom: ${props => props.borderColor ? `5px solid ${props.borderColor}` : ''};
  max-height: fit-content;
  width: fit-content;
  ${esm/* color */.$_}
`;
const ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
`;
const LinksWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  p: 3
}, props))`
  display: flex;
  flex-direction: column;
  ${index_esm/* space */.Dh}
`;
const BannerWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  m: 3
}, props))`
  /* let external project to define banner's width */
  ${index_esm/* layout */.bK}
  ${index_esm/* space */.Dh}
`;
const LinksList = styled_components_browser_esm/* default.ul */.ZP.ul`
  display: inline-grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(${props => props.lines}, auto);
`;
const LinkItem = styled_components_browser_esm/* default.li.attrs */.ZP.li.attrs(props => Object.assign({
  mr: 5
}, props))`
  list-style: none;
  line-height: 24px;
  ${index_esm/* space */.Dh}
`;
const menu_content_styles_Link = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z)``;
const SubsectionTitle = styled_components_browser_esm/* default.li.attrs */.ZP.li.attrs(props => Object.assign({
  color: 'primary.base',
  fontSize: 1,
  fontWeight: 'bold',
  px: 2
}, props))`
  list-style: none;
  line-height: 24px;
  ${esm/* color */.$_}
  ${index_esm/* typography */.cp}
  ${index_esm/* space */.Dh}
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuContent/menu-content.js








const MenuContent = _ref => {
  let {
    data
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data"]);

  const {
    subcategoriesList,
    url: categoryUrl,
    label: categoryLabel,
    borderColor,
    banner,
    footerData,
    linePerCol = 16,
    subsections
  } = data;
  const {
    onMenuItemClick
  } = props;
  return /*#__PURE__*/react.createElement(MenuBox, {
    "data-testid": "menu-box-elem",
    borderColor: borderColor
  }, /*#__PURE__*/react.createElement(ContentWrapper, null, subcategoriesList ? /*#__PURE__*/react.createElement(LinksWrapper, null, /*#__PURE__*/react.createElement(LinksList, {
    lines: linePerCol
  }, subcategoriesList.map((link, index) => /*#__PURE__*/react.createElement(LinkItem, {
    key: `link-item-${index}`
  }, /*#__PURE__*/react.createElement(menu_content_styles_Link, (0,esm_extends/* default */.Z)({}, link.highlight ? {
    color: borderColor
  } : {}, {
    href: link.url,
    onClick: e => onMenuItemClick(e, link, 'departamento')
  }), link.label))), subsections ? subsections.map((subsection, index) => {
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: `subsection-${index}`
    }, /*#__PURE__*/react.createElement("div", null), /*#__PURE__*/react.createElement(SubsectionTitle, {
      key: `subsection-title-${index}`
    }, subsection.label), subsection.linksList.map((subsectionLink, indexLink) => /*#__PURE__*/react.createElement(LinkItem, {
      key: `subsection-link-item-${index}-${indexLink}`
    }, /*#__PURE__*/react.createElement(menu_content_styles_Link, {
      onClick: e => onMenuItemClick(e, subsectionLink, 'subsection'),
      href: subsectionLink.url
    }, subsectionLink.label))));
  }) : /*#__PURE__*/react.createElement(react.Fragment, null)), categoryUrl && categoryUrl !== '#' && categoryLabel ? /*#__PURE__*/react.createElement(menu_content_styles_Link, {
    color: borderColor,
    href: categoryUrl
  }, "+ ", categoryLabel) : /*#__PURE__*/react.createElement(react.Fragment, null)) : /*#__PURE__*/react.createElement(react.Fragment, null), banner && banner.component && /*#__PURE__*/react.createElement(BannerWrapper, {
    "data-testid": "banner-elem",
    width: banner.width
  }, banner.component)), footerData ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(atoms/* HorizontalRule */.bo, null), /*#__PURE__*/react.createElement(menu_footer, {
    data: footerData,
    onMenuFooterClick: (e, label) => onMenuItemClick(e, label, 'footer')
  })) : /*#__PURE__*/react.createElement(react.Fragment, null));
};

MenuContent.defaultProps = {
  onMenuItemClick: () => ({}),
  data: {}
};
 false ? 0 : void 0;
/* harmony default export */ var menu_content = (MenuContent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuContent/index.js


/***/ }),

/***/ 28982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ message_box; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MessageBox/message-box.styles.js



const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(() => ({
  flexDirection: ['column', 'row', 'row'],
  justifyContent: 'space-evenly',
  left: 0,
  lineHeight: 'big',
  padding: 3,
  position: 'fixed',
  top: ['0', 'inherit', 'inherit'],
  width: '100%',
  zIndex: 3
}))`
  background-color: ${props => (0,esm/* themeGet */.R)('baseColors.overlay.dark')(props)};
  ${(0,esm/* getMediaQuery */.aK)('small')} {
    bottom: 0;
    max-height: 100px;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MessageBox/message-box.js




const MessageBox = ({
  children
}) => {
  return /*#__PURE__*/react.createElement(Container, null, children);
};

 false ? 0 : void 0;
MessageBox.defaultProps = {
  children: undefined
};
/* harmony default export */ var message_box = (MessageBox);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MessageBox/index.js


/***/ }),

/***/ 3310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ offer_timer; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/OfferTimer/offer-timer.styles.js



const OfferTimerContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)(props.bg)(props)};
  max-width: 208px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/OfferTimer/offer-timer.js










const OfferTimer = _ref => {
  let {
    restrictions = {},
    height,
    fontSize,
    displayMode,
    text,
    bg
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["restrictions", "height", "fontSize", "displayMode", "text", "bg"]);

  const [timer, setTimer] = (0,react.useState)('');
  const [shouldRender, setShouldRender] = (0,react.useState)(false);
  const isDisplayModeList = displayMode === constants/* LIST */.IY;
  (0,react.useEffect)(() => {
    const updateTimer = () => {
      const formattedDate = (0,utils/* fetchFormattedTime */.bd)();
      const {
        show,
        timeRemainingFormatted
      } = (0,utils/* checkAndCalculateTime */.lb)(restrictions, formattedDate);
      setShouldRender(show);

      if (show) {
        setTimer(timeRemainingFormatted);
      }
    };

    const intervalId = setInterval(updateTimer, 1000);
    updateTimer();
    return () => clearInterval(intervalId);
  }, [restrictions]);
  if (!shouldRender) return null;
  return /*#__PURE__*/react.createElement(OfferTimerContainer, (0,esm_extends/* default */.Z)({
    "data-testid": "offer-timer",
    borderRadius: 2,
    justifyContent: "center",
    alignItems: "center",
    bg: bg,
    height: height,
    mt: [isDisplayModeList && 1, 2],
    mr: isDisplayModeList ? '10px' : 0
  }, props), /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    color: "#FFF5F0",
    height: ['12px', '14px'],
    width: ['12px', '14px'],
    name: "Timer",
    mr: 1
  }), /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    fontSize: fontSize
  }, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "white",
    as: "span"
  }, text), ' ', /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "white",
    as: "time",
    fontWeight: "bold",
    dateTime: (0,utils/* formatTimeRemainingToISO */.J5)(timer)
  }, timer)));
};

 false ? 0 : void 0;
OfferTimer.defaultProps = {
  height: '20px',
  fontSize: '10px',
  displayMode: constants/* LIST */.IY,
  bg: '#9110C2',
  text: 'Oferta termina em'
};
/* harmony default export */ var offer_timer = (OfferTimer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/OfferTimer/index.js


/***/ }),

/***/ 19620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Pagination; }
});

// UNUSED EXPORTS: usePagination

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Pagination/usePagination.js
// ref: https://github.com/mui-org/material-ui/blob/master/LICENSE
// https://dev.to/namirsab/comment/2050
const range = (start, end) => {
  const length = end - start + 1;
  return Array.from({
    length
  }, (_, i) => start + i);
};
const getHref = (path, page) => {
  const pathPage = `page=${page}`;

  if (path.includes('page=')) {
    const [initialPath] = path.split('page=');
    if (page === 1) return initialPath.substring(0, initialPath.length - 1);
    return `${initialPath}${pathPage}`;
  }

  if (page === 1) return path;
  return path.includes('?') ? `${path}&${pathPage}` : `${path}?${pathPage}`;
};
function usePagination(props = {}) {
  const {
    boundaryCount: boundaryCountProp = 1,
    count = 1,
    disabled,
    path = '',
    page = 1,
    onChange,
    siblingCount = 1
  } = props;

  const handleClick = (event, value) => {
    onChange(event, value);
  };

  const boundaryCount = boundaryCountProp - 1;
  const startPages = range(1, Math.min(boundaryCount + 1, count));
  const endPages = range(Math.max(count - boundaryCount, boundaryCount + 2), count);
  const siblingsStart = Math.max(Math.min( // Natural start
  page - siblingCount, // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 2), // Greater than startPages
  boundaryCount + 3);
  const siblingsEnd = Math.min(Math.max( // Natural end
  page + siblingCount, // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 3), // Less than endPages
  endPages[0] - 2);
  const itemList = ['previous', ...startPages, // Start ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsStart > boundaryCount + 3 ? ['ellipsis'] : 2 + boundaryCount < count - boundaryCount - 1 ? [2 + boundaryCount] : []), // Sibling pages
  ...range(siblingsStart, siblingsEnd), // End ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsEnd < count - boundaryCount - 2 ? ['ellipsis'] : count - boundaryCount - 1 > boundaryCount + 1 ? [count - boundaryCount - 1] : []), ...endPages, 'next']; // Map the button type to its page number

  const pageByType = {
    first: 1,
    previous: page - 1,
    next: page + 1,
    last: count
  };
  const items = itemList.map(item => {
    return typeof item === 'number' ? {
      onClick: event => {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled,
      href: getHref(path, item),
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: event => {
        handleClick(event, pageByType[item]);
      },
      type: item,
      page: pageByType[item] || null,
      disabled: item === 'next' ? page >= count : page <= 1
    };
  });
  return {
    items
  };
}
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Pagination/pagination.styles.js

const Container = styled_components_browser_esm/* default.nav */.ZP.nav``;
const Content = styled_components_browser_esm/* default.ul */.ZP.ul`
  list-style: none;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;

  & > li {
    margin-right: 8px;
  }
`;
const PaginationItem = styled_components_browser_esm/* default.li */.ZP.li`
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 26px;
  min-width: 26px;
  height: 30px;
  border-radius: 2px;
  border: 0;
  font-weight: normal;
  padding: 5px;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaginationItem/index.js + 2 modules
var molecules_PaginationItem = __webpack_require__(81484);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Pagination/pagination.js






function Pagination(props) {
  const {
    items
  } = usePagination(props);

  function getAriaLabel(type, page, selected) {
    if (type === 'page') {
      return `${selected ? '' : 'Go to '}page ${page}`;
    }

    return `Go to ${type} page`;
  }

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    "aria-label": "pagination navigation"
  }), /*#__PURE__*/react.createElement(Content, null, items == null ? void 0 : items.map((item, index) => {
    const itemProps = Object.assign({}, item, {
      'aria-label': getAriaLabel(item.type, item.page, item.selected)
    });
    return /*#__PURE__*/react.createElement("li", {
      key: index
    }, /*#__PURE__*/react.createElement(molecules_PaginationItem/* default */.Z, (0,esm_extends/* default */.Z)({}, itemProps, {
      "data-testid": "pagination-item"
    })));
  })));
}
Pagination.defaultProps = {
  boundaryCount: 1,
  count: 1,
  disabled: false,
  page: 1,
  siblingCount: 1,
  onChange: () => {}
};
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Pagination/index.js



/***/ }),

/***/ 81484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PaginationItem; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaginationItem/pagintation-item.styles.js



const Ellipsis = styled_components_browser_esm/* default.div */.ZP.div``;
const Item = styled_components_browser_esm/* default.a */.ZP.a`
  display: flex;
  justify-content: center;
  align-items: center;

  background: none;
  background-color: ${props => props.selected && (0,build_esm/* getPaletteColor */.ow)('base')};
  color: ${props => (0,build_esm/* getPaletteColor */.ow)(props.selected ? 'text' : 'text.dark')(props)};
  padding: 5px;
  min-height: 26px;
  height: 30px;
  min-width: 26px;
  border: 0;
  border-radius: 2px;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  font-family: ${props => (0,build_esm/* themeGet */.R)('fontFamily')(props)};
  text-decoration: none;
`;
const IconButton = styled_components_browser_esm/* default.button */.ZP.button`
  visibility: ${props => props.disabled ? 'hidden' : 'visible'};
  border: 0;
  background: none;
  display: flex;
`;

const arrowStyle = props => ({
  width: 30,
  height: 30,
  color: props.disabled ? '#ccc' : '#333',
  cursor: props.disabled ? 'not-allowed' : 'pointer'
});

const Left = (0,styled_components_browser_esm/* default */.ZP)(esm/* ChevronLeft */.s$$).attrs(arrowStyle)``;
const Right = (0,styled_components_browser_esm/* default */.ZP)(esm/* ChevronRight */._Qn).attrs(arrowStyle)``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaginationItem/pagination-item.js




function PaginationItem(props) {
  const {
    onClick,
    type,
    page,
    disabled,
    href
  } = props;
  const icon = ['previous', 'next'].includes(type);
  if (type === 'ellipsis') return /*#__PURE__*/react.createElement(Ellipsis, null, "...");
  return type === 'page' ? /*#__PURE__*/react.createElement(Item, (0,esm_extends/* default */.Z)({
    href: href,
    role: "button",
    title: `página ${page}`,
    onClick: !props.selected && onClick
  }, props), page) : /*#__PURE__*/react.createElement(IconButton, (0,esm_extends/* default */.Z)({
    onClick: onClick
  }, props), icon && (type === 'previous' ? /*#__PURE__*/react.createElement(Left, {
    disabled: disabled
  }) : /*#__PURE__*/react.createElement(Right, {
    disabled: disabled
  })));
}
PaginationItem.defaultProps = {
  disabled: false,
  href: null,
  onClick: () => {},
  page: null,
  selected: false
};
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaginationItem/index.js


/***/ }),

/***/ 563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ payment_methods; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var build_esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/payment-methods.styles.js







const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)``;
const CardTab = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  padding: 2px;
  border: solid 2px
    ${({
  selected
}) => selected ? (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('primary') : (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('darker')};
  border-radius: 2px;
  width: 50px;
  justify-content: center;
  margin: 0 2px;
`;
const List = (0,styled_components_browser_esm/* default */.ZP)(atoms/* TabList */.td)`
  display: flex;
  margin: 0 10px;
`;
const InstallmentTable = styled_components_browser_esm/* default.table */.ZP.table`
  width: 100%;
  border-spacing: unset;

  & tr:nth-child(n + 13) {
    display: ${({
  allVisible
}) => allVisible ? 'table-row' : 'none'};
  }
`;
const TableHeading = styled_components_browser_esm/* default.thead */.ZP.thead`
  font-family: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('Helvetica')(props)};
  color: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('colors.darkSilver')(props)};
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
`;
const ProductFreight = styled_components_browser_esm/* default.span */.ZP.span`
  font-weight: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.light')(props)};
  font-style: italic;
`;
const FeeHeading = styled_components_browser_esm/* default.th */.ZP.th`
  text-align: left;
  padding: 0 10px;
`;
const FeeBody = styled_components_browser_esm/* default.td */.ZP.td`
  padding: 8px 10px;
  text-align: left;
  color: ${props => (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('base')(props)};
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
`;
const InstallmentAmount = styled_components_browser_esm/* default.span */.ZP.span`
  font-weight: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.medium')(props)};
`;
const TotalHeading = styled_components_browser_esm/* default.th */.ZP.th`
  text-align: right;
  padding: 0 10px;
`;
const TotalBody = styled_components_browser_esm/* default.td */.ZP.td`
  font-family: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('Helvetica')(props)};
  color: ${props => (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('base')(props)};
  padding: 0px 10px;
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  text-align: right;
`;
const PlanTr = styled_components_browser_esm/* default.tr */.ZP.tr`
  background-color: ${props => props.index % 2 === 0 ? (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('darker')(props) : null};
`;
const NumberInstallment = styled_components_browser_esm/* default.p */.ZP.p`
  margin-top: 4px;
  margin-bottom: 8px;
`;
const Title = styled_components_browser_esm/* default.span */.ZP.span`
  display: flex;
  align-items: center;
  color: ${props => (0,stereo_ui_styles_build_esm/* getPaletteColor */.ow)('primary.base')(props)};
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  margin: 10px;
  font-weight: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeight.normal')(props)};
`;
const Amount = styled_components_browser_esm/* default.span */.ZP.span`
  color: ${props => (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('base')(props)};
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  font-weight: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.medium')(props)};
`;
const Discount = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: #429502;
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  margin-left: 4px;
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)``;
const InstallmentMethodText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: ${props => props.luizaCard ? '#429502' : (0,stereo_ui_styles_build_esm/* getPaletteColor */.ow)('darkSilver')(props)};
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
`;
const SlipContent = styled_components_browser_esm/* default.div */.ZP.div`
  margin: 10px;
`;
const ShowMoreButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)`
  width: 100%;
`;
const LegalText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  padding: 8px 4px 8px 10px;
  font-size: 12px;
  font-family: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('Helvetica')(props)};
  color: #8c8c8c;
  font-style: italic;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/payment-methods-tab.js







const PaymentMethodsTab = ({
  onChange,
  payments
}) => {
  const tabs = ['luizaCard', 'creditCard', 'pix', 'bankSlip'];
  return /*#__PURE__*/react.createElement(List, {
    "data-testid": "payments-list",
    onChange: onChange
  }, tabs.map(tab => {
    var _payments$tab;

    return !!(payments != null && (_payments$tab = payments[tab]) != null && _payments$tab.installmentPlans) && /*#__PURE__*/react.createElement(atoms/* Tab */.OK, {
      value: payments[tab].id,
      key: `${tab}-tab`,
      "data-testid": `${tab}-tab`
    }, /*#__PURE__*/react.createElement(CardTab, null, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: (0,utils/* capitalize */.kC)(tab)
    })));
  }));
};

PaymentMethodsTab.defaultProps = {
  payments: {}
};
 false ? 0 : void 0;
/* harmony default export */ var payment_methods_tab = (PaymentMethodsTab);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/payment-methods.data.js
const LuCardLabel = `Cartão Luiza`;
const CreditCardLabel = `Cartão de crédito`;
const BankSlipLabel = `Boleto bancário`;
const PixLabel = `Pix`;
const ProductPlusFreight = `(Produto + Frete)`;
const InstallmentNumberLabel = `Numero de parcelas`;
const TotalLabel = `Total`;
const DiscountLabel = `% de desconto`;
const SlipDescription = `No boleto bancário, que será gerado na finalização da sua compra.`;
const PixDescription = `No PIX, com o código que será gerado na finalização da sua compra.`;
const InstallmentLabel = installment => {
  return parseInt(installment, 10) >= 10 ? `${installment}x de` : `0${installment}x de`;
};
const WithInterest = `com juros`;
const WithoutInterest = `sem juros`;
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/payment-table.js








const PaymentTable = _ref => {
  let {
    installments,
    showAll,
    showMoreLabel,
    luizaCard
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["installments", "showAll", "showMoreLabel", "luizaCard"]);

  const [allVisible, setAllVisible] = (0,react.useState)(showAll);

  const shouldHasInterest = plan => {
    return Boolean(Number((plan == null ? void 0 : plan.interestAmount) || 0));
  };

  const hasOneInterest = installments.some(plan => !!Number(plan.interestAmount));

  const renderInstallmentMethod = plan => {
    const hasInterest = shouldHasInterest(plan);
    const text = hasInterest ? WithInterest : WithoutInterest;
    const luizaCardFlag = !hasInterest ? luizaCard : false;
    const shouldRender = hasInterest && !luizaCard || !hasInterest && luizaCard !== null;
    return shouldRender ? /*#__PURE__*/react.createElement(InstallmentMethodText, {
      luizaCard: luizaCardFlag
    }, text) : null;
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(InstallmentTable, (0,esm_extends/* default */.Z)({
    allVisible: allVisible
  }, props), /*#__PURE__*/react.createElement(TableHeading, null, /*#__PURE__*/react.createElement("tr", null, /*#__PURE__*/react.createElement(FeeHeading, null, /*#__PURE__*/react.createElement(ProductFreight, null, ProductPlusFreight), /*#__PURE__*/react.createElement(NumberInstallment, null, InstallmentNumberLabel)), /*#__PURE__*/react.createElement(TotalHeading, null, TotalLabel))), /*#__PURE__*/react.createElement("tbody", null, installments.map((plan, index) => {
    const hasInterest = shouldHasInterest(plan);
    return /*#__PURE__*/react.createElement(PlanTr, {
      index: index,
      key: plan == null ? void 0 : plan.installment
    }, /*#__PURE__*/react.createElement(FeeBody, null, /*#__PURE__*/react.createElement("span", null, Number(plan == null ? void 0 : plan.installment) > 1 && InstallmentLabel(plan == null ? void 0 : plan.installment), ' ', /*#__PURE__*/react.createElement(InstallmentAmount, null, (0,build_esm/* currencyFormatter */.oB)({
      value: plan == null ? void 0 : plan.installmentAmount
    }), hasInterest && luizaCard && '*')), Number(plan == null ? void 0 : plan.installment) === 1 && /*#__PURE__*/react.createElement(react.Fragment, null, !!Number((plan == null ? void 0 : plan.discount) || 0) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Discount, {
      as: "span"
    }, Number(plan == null ? void 0 : plan.discount), DiscountLabel))), renderInstallmentMethod(plan)), /*#__PURE__*/react.createElement(TotalBody, null, Number(plan == null ? void 0 : plan.installment) > 1 && (0,build_esm/* currencyFormatter */.oB)({
      value: plan == null ? void 0 : plan.totalAmount
    })));
  }))), hasOneInterest && luizaCard && /*#__PURE__*/react.createElement(LegalText, {
    "data-testid": "legal-text"
  }, "*Juros: Todos os encargos da opera\xE7\xE3o, como juros, custo de parcelamento e outras tarifas est\xE3o inclu\xEDdas neste valor."), (installments || []).length > 12 && !allVisible && /*#__PURE__*/react.createElement(ShowMoreButton, {
    "data-testid": "show-more",
    size: "small",
    onClick: () => setAllVisible(true)
  }, showMoreLabel));
};

PaymentTable.defaultProps = {
  installments: [],
  showAll: true,
  luizaCard: false,
  showMoreLabel: 'veja mais'
};
 false ? 0 : void 0;
/* harmony default export */ var payment_table = (PaymentTable);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/payment-methods.js












const getPaymentsById = payments => Object.values(payments).reduce((acc, item) => Object.assign({}, acc, {
  [item.id]: item
}), {});

const PaymentMethods = ({
  asTab,
  showMoreLabel,
  onChange,
  payments
}) => {
  var _pix$installmentPlans, _pix$installmentPlans2, _pix$installmentPlans3, _pix$installmentPlans4, _pix$installmentPlans5, _pix$installmentPlans6, _bankSlip$installment, _bankSlip$installment2, _bankSlip$installment3, _bankSlip$installment4, _bankSlip$installment5, _bankSlip$installment6;

  const {
    luizaCard,
    creditCard,
    bankSlip,
    pix
  } = payments;
  const [value, setValue] = (0,react.useState)((luizaCard == null ? void 0 : luizaCard.id) || (creditCard == null ? void 0 : creditCard.id) || (pix == null ? void 0 : pix.id) || (bankSlip == null ? void 0 : bankSlip.id) || '');
  const paymentById = getPaymentsById(payments);

  const handleChange = (e, paymentMethodId) => {
    setValue(paymentMethodId);
    onChange(paymentById[paymentMethodId]);
  };

  const Item = asTab ? atoms/* TabPanel */.x4 : Flex/* default */.Z;
  const itemProps = asTab ? {
    width: '100%'
  } : {
    display: 'block',
    flex: '1 1'
  };
  return /*#__PURE__*/react.createElement(atoms/* TabContext */.q5, {
    value: value
  }, asTab && /*#__PURE__*/react.createElement(payment_methods_tab, {
    onChange: handleChange,
    payments: payments
  }), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    justifyContent: "space-between",
    gap: 2,
    flexWrap: "wrap"
  }, (luizaCard == null ? void 0 : luizaCard.installmentPlans) && /*#__PURE__*/react.createElement(Item, (0,esm_extends/* default */.Z)({}, itemProps, {
    "data-testid": "luizaCard-panel",
    value: luizaCard == null ? void 0 : luizaCard.id
  }), /*#__PURE__*/react.createElement(Title, null, !asTab && /*#__PURE__*/react.createElement(esm/* LuizaCard */.OTZ, {
    mr: 2
  }), " ", LuCardLabel), /*#__PURE__*/react.createElement(payment_table, {
    luizaCard: luizaCard == null ? void 0 : luizaCard.installmentPlans,
    showAll: asTab,
    "data-testid": "luizaCard-table",
    showMoreLabel: showMoreLabel,
    installments: luizaCard.installmentPlans
  })), (creditCard == null ? void 0 : creditCard.installmentPlans) && /*#__PURE__*/react.createElement(Item, (0,esm_extends/* default */.Z)({}, itemProps, {
    "data-testid": "creditCard-panel",
    value: creditCard == null ? void 0 : creditCard.id
  }), /*#__PURE__*/react.createElement(Title, null, !asTab && /*#__PURE__*/react.createElement(esm/* CreditCard */.aBT, {
    mr: 2
  }), " ", CreditCardLabel), /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(payment_table, {
    showAll: asTab,
    "data-testid": "creditCard-table",
    showMoreLabel: showMoreLabel,
    installments: creditCard.installmentPlans
  }))), pix && /*#__PURE__*/react.createElement(Item, (0,esm_extends/* default */.Z)({}, itemProps, {
    "data-testid": "pix-panel",
    value: pix == null ? void 0 : pix.id
  }), /*#__PURE__*/react.createElement(Title, null, !asTab && /*#__PURE__*/react.createElement(esm/* Pix */.wrL, {
    mr: 2
  }), " ", PixLabel), /*#__PURE__*/react.createElement(SlipContent, null, /*#__PURE__*/react.createElement(Amount, null, (0,build_esm/* currencyFormatter */.oB)({
    value: pix == null ? void 0 : (_pix$installmentPlans = pix.installmentPlans) == null ? void 0 : (_pix$installmentPlans2 = _pix$installmentPlans[0]) == null ? void 0 : _pix$installmentPlans2.installmentAmount
  })), !!Number(pix == null ? void 0 : (_pix$installmentPlans3 = pix.installmentPlans) == null ? void 0 : (_pix$installmentPlans4 = _pix$installmentPlans3[0]) == null ? void 0 : _pix$installmentPlans4.discount) && /*#__PURE__*/react.createElement(Discount, {
    as: "span"
  }, Number(pix == null ? void 0 : (_pix$installmentPlans5 = pix.installmentPlans) == null ? void 0 : (_pix$installmentPlans6 = _pix$installmentPlans5[0]) == null ? void 0 : _pix$installmentPlans6.discount), DiscountLabel), /*#__PURE__*/react.createElement(Description, {
    fontSize: 0
  }, PixDescription))), bankSlip && /*#__PURE__*/react.createElement(Item, (0,esm_extends/* default */.Z)({}, itemProps, {
    "data-testid": "bankSlip-panel",
    value: bankSlip == null ? void 0 : bankSlip.id
  }), /*#__PURE__*/react.createElement(Title, null, !asTab && /*#__PURE__*/react.createElement(esm/* BankSlip */.c4o, {
    mr: 2
  }), " ", BankSlipLabel), /*#__PURE__*/react.createElement(SlipContent, null, /*#__PURE__*/react.createElement(Amount, null, (0,build_esm/* currencyFormatter */.oB)({
    value: bankSlip == null ? void 0 : (_bankSlip$installment = bankSlip.installmentPlans) == null ? void 0 : (_bankSlip$installment2 = _bankSlip$installment[0]) == null ? void 0 : _bankSlip$installment2.installmentAmount
  })), !!Number(bankSlip == null ? void 0 : (_bankSlip$installment3 = bankSlip.installmentPlans) == null ? void 0 : (_bankSlip$installment4 = _bankSlip$installment3[0]) == null ? void 0 : _bankSlip$installment4.discount) && /*#__PURE__*/react.createElement(Discount, {
    as: "span"
  }, Number(bankSlip == null ? void 0 : (_bankSlip$installment5 = bankSlip.installmentPlans) == null ? void 0 : (_bankSlip$installment6 = _bankSlip$installment5[0]) == null ? void 0 : _bankSlip$installment6.discount), DiscountLabel), /*#__PURE__*/react.createElement(Description, {
    fontSize: 0
  }, SlipDescription)))));
};

PaymentMethods.defaultProps = {
  asTab: true,
  showMoreLabel: 'veja mais',
  onChange: () => ({}),
  payments: {}
};
 false ? 0 : void 0;
/* harmony default export */ var payment_methods = (PaymentMethods);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/index.js


/***/ }),

/***/ 23458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_Price; }
});

// UNUSED EXPORTS: PriceMiniature

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/price.styles.js







const Unavailable = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
const unavailableLabelPadding = {
  [constants/* MINIATURE */.Co]: styled_components_browser_esm/* css */.iv`
    padding: 4px 4px;
  `,
  [constants/* LIST */.IY]: styled_components_browser_esm/* css */.iv`
    padding: 12px 35px;
  `,
  DEFAULT: styled_components_browser_esm/* css */.iv`
    padding: 12px 12px;
  `
};
const UnavailableLabel = styled_components_browser_esm/* default.span */.ZP.span`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  border-radius: 4px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('light')(props)};
  display: inline-block;
  background-color: ${props => (0,build_esm/* getPaletteColor */.ow)('background.secondary')(props)};
  ${props => unavailableLabelPadding[props.display] || unavailableLabelPadding.DEFAULT}
`;

const resolvePriceFontSize = isList => isList ? 3 : 5;

const PriceDefault = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(props => ({
  fontSize: [resolvePriceFontSize(props.isList), 5],
  lineHeight: 'fontSize'
}))`
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  align-self: end;
  position: relative;
  span {
    font-size: ${_ref => {
  let {
    isList
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["isList"]);

  return isList ? (0,build_esm/* themeGet */.R)('fontSizes.0')(props) : (0,build_esm/* themeGet */.R)('fontSizes.1')(props);
}}px;
    font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
    line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.thin')(props)}px;
  }
  ${index_esm/* space */.Dh}
  ${index_esm/* typography */.cp}
`;
const PriceContent = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(_ref2 => {
  let style = Object.assign({}, _ref2);
  return Object.assign({
    mt: '8px'
  }, style);
})`
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.big')(props)};
  ${index_esm/* typography */.cp}
`;
const Discount = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: ${props => (0,build_esm/* getPaletteColor */.ow)('secondary.base')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
`;
const OriginalPrice = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(({
  isList
}) => ({
  fontSize: [isList ? 0 : 1, 1],
  lineHeight: 'fontSize',
  fontWeight: !isList ? 'regular' : null,
  color: isList ? 'text.scratched' : 'text.light'
}))`
  margin: 0;
  text-align: left;
  text-decoration: line-through;
  ${index_esm/* typography */.cp}
  ${build_esm/* color */.$_}
`;
const MethodDescription = styled_components_browser_esm/* default.span */.ZP.span`
  margin-left: 0.3rem;
`;
const PriceValue = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/PriceMiniature/price-miniature.style.js





const PriceMiniatureLabel = styled_components_browser_esm/* default.p */.ZP.p`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.standard')(props)}px;
`;
const PriceMiniature = (0,styled_components_browser_esm/* default */.ZP)(PriceDefault)`
  text-align: center;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.small')(props)};
  letter-spacing: normal;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  p {
    padding: 3px 0px 0px;
  }
`;
const ProductMiniatureContent = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(_ref => {
  let style = Object.assign({}, _ref);
  return Object.assign({
    mt: '8px'
  }, style);
})`
  line-height: 6px;
  ${index_esm/* space */.Dh}
`;
const EmptyPrice = styled_components_browser_esm/* default.div */.ZP.div``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/price.text.js
const unavailable = 'Xiii, já foi tudo :(';
const inCash = `no Pix`;
const price_text_discount = `% de desconto no pix`;
const withInterest = 'com juros';
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/PriceMiniature/price-miniature.js






const PriceMiniatureComponent = ({
  price,
  paymentMethodDescription,
  showInCashInfo,
  style
}) => {
  if (!price) return /*#__PURE__*/react.createElement(EmptyPrice, {
    "data-testid": "empty-price-miniature"
  });
  return /*#__PURE__*/react.createElement(ProductMiniatureContent, style, /*#__PURE__*/react.createElement(PriceMiniature, {
    "data-testid": "price-miniature"
  }, (0,esm/* currencyFormatter */.oB)({
    value: price
  }), ' ', showInCashInfo && /*#__PURE__*/react.createElement(PriceMiniatureLabel, null, paymentMethodDescription || inCash)));
};

 false ? 0 : void 0;
PriceMiniatureComponent.defaultProps = {
  price: '',
  paymentMethodDescription: '',
  showInCashInfo: false,
  style: {}
};
/* harmony default export */ var price_miniature = (PriceMiniatureComponent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/PriceMiniature/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Installment/index.js + 2 modules
var Installment = __webpack_require__(97769);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/PriceDefault/price-default.utils.js

const returnInstallmentInfo = ({
  installment,
  minimumInstallment
}) => {
  const installmentPrice = installment == null ? void 0 : installment.totalAmount;
  const hasInstallment = !!(installment != null && installment.amount && (installment == null ? void 0 : installment.quantity) > minimumInstallment && installment != null && installment.totalAmount);
  const isInstallmentWithoutInterest = (installment == null ? void 0 : installment.paymentMethodDescription) !== withInterest;
  return {
    hasInstallment,
    installmentPrice,
    isInstallmentWithoutInterest
  };
};
const returnPriceInfo = ({
  finalPrice,
  hideOriginalPrice,
  installmentPrice,
  isInstallmentWithoutInterest,
  price
}) => {
  const isDifferentFinalPrice = parseFloat(price) !== parseFloat(installmentPrice) && parseFloat(price) !== parseFloat(finalPrice);
  const showOriginalPrice = isDifferentFinalPrice && isInstallmentWithoutInterest && !hideOriginalPrice;
  return {
    showOriginalPrice
  };
};
const returnDiscountInfo = ({
  finalPrice,
  installmentPrice,
  showDiscount,
  showDiscountOnlyCashInfo,
  showInCashInfo
}) => {
  const isFinalPriceLower = parseFloat(finalPrice) < parseFloat(installmentPrice);
  const isInstallmentPriceAbsent = !installmentPrice;
  const showDiscountValue = showInCashInfo && showDiscount && (!showDiscountOnlyCashInfo || isInstallmentPriceAbsent || isFinalPriceLower);
  return {
    showDiscountValue
  };
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/PriceDefault/price-default.js









const PriceDefaultComponent = ({
  discount,
  finalPrice,
  hideOriginalPrice,
  installment,
  isList,
  minimumInstallment,
  installmentFormat,
  paymentMethodDescription,
  price,
  showDiscount,
  showDiscountOnlyCashInfo,
  showInCashInfo,
  style
}) => {
  const {
    hasInstallment,
    installmentPrice,
    isInstallmentWithoutInterest
  } = returnInstallmentInfo({
    installment,
    minimumInstallment
  });
  const {
    showOriginalPrice
  } = returnPriceInfo({
    finalPrice,
    hideOriginalPrice,
    installmentPrice,
    isInstallmentWithoutInterest,
    price
  });
  const {
    showDiscountValue
  } = returnDiscountInfo({
    finalPrice,
    installmentPrice,
    showDiscount,
    showDiscountOnlyCashInfo,
    showInCashInfo
  });
  return /*#__PURE__*/react.createElement(PriceContent, style, /*#__PURE__*/react.createElement(PriceDefault, {
    "data-testid": "price-default",
    isList: isList
  }, /*#__PURE__*/react.createElement(react.Fragment, null, showOriginalPrice && /*#__PURE__*/react.createElement(OriginalPrice, {
    "data-testid": "price-original",
    isList: isList
  }, (0,esm/* currencyFormatter */.oB)({
    value: price
  })), hasInstallment && /*#__PURE__*/react.createElement(Installment/* default */.Z, {
    mt: 2,
    information: installment,
    minimumInstallment: minimumInstallment,
    isList: isList,
    format: installmentFormat
  }), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    alignItems: "center"
  }, /*#__PURE__*/react.createElement(PriceValue, {
    "data-testid": "price-value"
  }, hasInstallment && /*#__PURE__*/react.createElement("span", null, "ou "), (0,esm/* currencyFormatter */.oB)({
    value: finalPrice
  })), paymentMethodDescription ? /*#__PURE__*/react.createElement(MethodDescription, {
    "data-testid": "in-cash"
  }, paymentMethodDescription, ' ') : /*#__PURE__*/react.createElement(react.Fragment, null, (!installmentPrice || parseFloat(finalPrice) < parseFloat(installmentPrice)) && /*#__PURE__*/react.createElement(MethodDescription, {
    "data-testid": "in-cash"
  }, inCash))), showDiscountValue && /*#__PURE__*/react.createElement(Discount, {
    as: "span"
  }, "(", `${Number(discount)}${price_text_discount}`, ")"))));
};

 false ? 0 : void 0;
PriceDefaultComponent.defaultProps = {
  hideOriginalPrice: false
};
/* harmony default export */ var price_default = (PriceDefaultComponent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/PriceDefault/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/price.js







/**
 * @function
 * @name Price
 * @prop {number|string} price - price from (original price)
 * @prop {number|string} fullPrice - price to (current sale price)
 * @prop {number|string} bestPrice - price with some discount
 */

const Price = ({
  display,
  price,
  paymentMethodDescription,
  bestPrice,
  fullPrice,
  discount,
  installment,
  showInCashInfo,
  showDiscount,
  showDiscountOnlyCashInfo,
  isList,
  minimumInstallment,
  installmentFormat,
  style,
  hideOriginalPrice
}) => {
  const finalPrice = bestPrice || fullPrice || price;
  const showInCash = Boolean(showInCashInfo && price !== finalPrice && Number(discount));

  if (!finalPrice) {
    return /*#__PURE__*/react.createElement(Unavailable, {
      "data-testid": "price-unavailable"
    }, /*#__PURE__*/react.createElement(UnavailableLabel, {
      display: display
    }, unavailable));
  }

  return display === constants/* MINIATURE */.Co ? /*#__PURE__*/react.createElement(price_miniature, {
    style: style,
    price: finalPrice,
    showInCashInfo: showInCash,
    paymentMethodDescription: paymentMethodDescription
  }) : /*#__PURE__*/react.createElement(price_default, {
    style: style,
    price: price,
    finalPrice: finalPrice,
    discount: discount,
    installment: installment,
    showInCashInfo: showInCash,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    paymentMethodDescription: paymentMethodDescription,
    isList: isList,
    minimumInstallment: minimumInstallment,
    installmentFormat: installmentFormat,
    hideOriginalPrice: hideOriginalPrice
  });
};

 false ? 0 : void 0;
Price.defaultProps = {
  display: constants/* GALLERY */.yg,
  isList: true,
  price: '',
  bestPrice: '',
  discount: '',
  hideOriginalPrice: false,
  installment: {
    amount: '',
    paymentMethodDescription: '',
    quantity: '',
    totalAmount: ''
  },
  installmentFormat: '',
  minimumInstallment: 1,
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: false
};
/* harmony default export */ var price = (Price);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/index.js



/* harmony default export */ var molecules_Price = (price);

/***/ }),

/***/ 58125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ price_range; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/moneyMask.js
var moneyMask = __webpack_require__(63113);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PriceRange/price-range.styles.js



const Wrapper = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj).attrs(props => Object.assign({
  my: 3,
  mx: 2,
  rowGap: 3
}, props))`
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 0.5fr 0.5fr;
  grid-template-areas:
    'input-values input-values'
    'slider-input slider-input'
    'apply-button apply-button';
`;
const InputValuesWrapper = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj).attrs(props => Object.assign({
  gap: 2
}, props))`
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-area: input-values;
`;
const SliderInputWrapper = styled_components_browser_esm/* default.div */.ZP.div`
  z-index: 0;
  grid-area: slider-input;
  position: relative;
`;
const InputLabel = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
`;
const ApplyButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  grid-area: apply-button;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PriceRange/price-range.js








const PriceRange = ({
  item,
  onApply,
  min,
  max,
  initialMin,
  initialMax
}) => {
  const [minValue, setMinValue] = (0,react.useState)();
  const [maxValue, setMaxValue] = (0,react.useState)();
  const [displayMin, setDisplayMin] = (0,react.useState)();
  const [displayMax, setDisplayMax] = (0,react.useState)();
  (0,react.useEffect)(() => {
    setMinValue(initialMin * 100);
    setDisplayMin((0,moneyMask/* default */.Z)(initialMin * 100).currency);
  }, [initialMin]);
  (0,react.useEffect)(() => {
    setMaxValue(initialMax * 100);
    setDisplayMax((0,moneyMask/* default */.Z)(initialMax * 100).currency);
  }, [initialMax]);
  const minDiv = minValue / 100;
  const maxDiv = maxValue / 100;
  const applyBtnDisabled = minDiv === initialMin && maxDiv === initialMax || !(0,utils/* isMinValidValue */.Z4)(minDiv, maxDiv, min, max) || !(0,utils/* isMaxValidValue */.rx)(maxDiv, minDiv, min, max);

  const handleChangeMax = (newValue, isRange = true) => {
    const {
      amount,
      currency
    } = (0,moneyMask/* default */.Z)(isRange ? newValue * 100 : newValue);
    setMaxValue(amount);
    setDisplayMax(currency);
  };

  const handleChangeMin = (newValue, isRange = true) => {
    const {
      amount,
      currency
    } = (0,moneyMask/* default */.Z)(isRange ? newValue * 100 : newValue);
    setMinValue(amount);
    setDisplayMin(currency);
  };

  const handleRangeChange = ({
    currentMax,
    currentMin
  }) => {
    handleChangeMax(currentMax);
    handleChangeMin(currentMin);
  };

  return /*#__PURE__*/react.createElement(Wrapper, {
    "data-testid": "price"
  }, /*#__PURE__*/react.createElement(InputValuesWrapper, null, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/react.createElement(InputLabel, {
    "data-testid": "price-range-min-label",
    fontSize: 0
  }, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "inherit"
  }, "M\xEDnimo:"), /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "inherit"
  }, (0,esm/* currencyFormatter */.oB)({
    value: min * 100,
    rightFilling: true
  }))), /*#__PURE__*/react.createElement(atoms/* Input */.II, {
    "data-testid": "price-range-min-input",
    value: displayMin,
    placeholder: "Ex: R$ 250,00",
    maxLength: 15,
    onChange: e => handleChangeMin(e.target.value, false)
  })), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/react.createElement(InputLabel, {
    "data-testid": "price-range-max-label",
    fontSize: 0
  }, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "inherit"
  }, "M\xE1ximo:"), /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "inherit"
  }, (0,esm/* currencyFormatter */.oB)({
    value: max * 100,
    rightFilling: true
  }))), /*#__PURE__*/react.createElement(atoms/* Input */.II, {
    "data-testid": "price-range-max-input",
    value: displayMax,
    placeholder: "Ex: R$ 500,00",
    maxLength: 15,
    onChange: e => handleChangeMax(e.target.value, false)
  }))), /*#__PURE__*/react.createElement(SliderInputWrapper, null, /*#__PURE__*/react.createElement(atoms/* RangeSlider */.U2, {
    maxAllowed: parseFloat(max),
    minAllowed: parseFloat(min),
    currentMax: parseFloat(maxDiv),
    currentMin: parseFloat(minDiv),
    onChange: handleRangeChange
  })), /*#__PURE__*/react.createElement(ApplyButton, {
    "data-testid": "price-range-apply-btn",
    full: true,
    onClick: event => onApply(event, {
      min: parseFloat(minValue / 100),
      max: parseFloat(maxValue / 100)
    }, item),
    disabled: applyBtnDisabled
  }, "Aplicar filtro"));
};

PriceRange.defaultProps = {
  item: {},
  onApply: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var price_range = (PriceRange);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PriceRange/index.js


/***/ }),

/***/ 65055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ radio_group; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/index.js + 2 modules
var Radio = __webpack_require__(70715);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RadioGroup/radio-group.styles.js



const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  > *:not(:last-child) {
    border-bottom: ${(0,esm/* themeGet */.R)('borders.0')};
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RadioGroup/radio-group.js







const RadioGroup = _ref => {
  let {
    options,
    selectedOption,
    onChange
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["options", "selectedOption", "onChange"]);

  return /*#__PURE__*/react.createElement(Container, null, options == null ? void 0 : options.map(option => {
    const {
      value,
      label,
      selected
    } = option;
    const checked = selected || value !== undefined && value === selectedOption || value === undefined && label === selectedOption;
    return /*#__PURE__*/react.createElement(Radio/* default */.Z, (0,esm_extends/* default */.Z)({
      key: value || label,
      value: value || label,
      label: label,
      checked: checked,
      onChange: e => onChange(e, option)
    }, props));
  }));
};

 false ? 0 : void 0;
RadioGroup.defaultProps = {
  options: [],
  selectedOption: '',
  onChange: () => {}
};
/* harmony default export */ var radio_group = (RadioGroup);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RadioGroup/index.js


/***/ }),

/***/ 11151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ rating_line; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RatingLine/rating-line.styles.js




const Line = styled_components_browser_esm/* default.li */.ZP.li`
  display: flex;
  align-items: center;
  column-gap: ${({
  columnGap
}) => columnGap || '8'}px;
`;
const Score = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)``;
const Count = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: ${({
  color
}) => (0,build_esm/* getTextColor */.uu)(color || 'light')};
`;
const StarIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Star */.Uxw)`
  margin-bottom: 1px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RatingLine/rating-line.js





function RatingLine({
  id,
  score,
  count,
  max,
  starColor,
  lineColor,
  fontweightScore,
  countColor,
  widthProgress,
  heightProgress,
  starSize,
  scoreFontSize,
  columnGap,
  as
}) {
  return /*#__PURE__*/react.createElement(Line, {
    columnGap: columnGap,
    as: as
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    alignItems: "center"
  }, /*#__PURE__*/react.createElement(Score, {
    fontSize: scoreFontSize,
    fontWeight: fontweightScore
  }, id), /*#__PURE__*/react.createElement(StarIcon, {
    width: starSize,
    height: starSize,
    color: starColor
  })), /*#__PURE__*/react.createElement(atoms/* LinearProgress */.uk, {
    height: heightProgress,
    width: widthProgress,
    value: score,
    max: max,
    color: lineColor
  }), /*#__PURE__*/react.createElement(Count, {
    "data-testid": "rating-value",
    fontSize: scoreFontSize,
    color: countColor
  }, count));
}

RatingLine.defaultProps = {
  id: 0,
  score: 0,
  count: '0',
  widthProgress: '90px',
  heightProgress: '6px',
  as: 'li',
  starSize: 15,
  scoreFontSize: 0,
  columnGap: 8
};
 false ? 0 : void 0;
/* harmony default export */ var rating_line = (RatingLine);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RatingLine/index.js


/***/ }),

/***/ 73172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ review; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/review.styles.js




const Wrapper = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  align-items: center;
`;
const Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(props => ({
  fontSize: [props.fontSize || 0, 1, 1],
  fontWeight: 'regular',
  as: 'span',
  color: 'text.scratched'
}))`
  display: inline-block;
  margin-left: 5px;
  ${props => props.format === 'label' && styled_components_browser_esm/* css */.iv`
      margin-bottom: 2px;
    `}
  ${index_esm/* typography */.cp}
  ${build_esm/* color */.$_}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/review.js







const Review = _ref => {
  let {
    min,
    max,
    count,
    emptyOutline,
    minCount,
    score = 0,
    format,
    label,
    fontSize,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["min", "max", "count", "emptyOutline", "minCount", "score", "format", "label", "fontSize", "onClick"]);

  const stars = Array.from(Array(max - min).keys());
  const isScoreInteger = Number.isInteger(score);
  const formatByType = {
    count,
    label,
    'score-count': `${score.toFixed(1) || 0} (${count})`
  };
  const showLabel = format === 'label' || count >= minCount;

  const getIcon = (isPlaceHolder, starItem) => {
    const isLastStar = starItem === Math.floor(score);

    if (!isScoreInteger && isLastStar) {
      return 'StarHalf';
    }

    if (!isPlaceHolder && emptyOutline) {
      return 'StarOutline';
    }

    return isPlaceHolder ? 'StarOutline' : 'Star';
  };

  const getColor = () => score === 0 && !emptyOutline ? 'stars.disabled' : 'stars.base';

  const starRatingAriaLabel = `${score.toFixed(1) || 0} de ${max} estrelas, ${count} classificações`;
  return /*#__PURE__*/react.createElement(Wrapper, {
    onClick: onClick,
    "data-testid": "review",
    "aria-label": starRatingAriaLabel
  }, stars.map(i => {
    const isPlaceHolder = score && score <= i;
    return /*#__PURE__*/react.createElement(esm/* Icon */.JO$, (0,esm_extends/* default */.Z)({
      name: getIcon(isPlaceHolder, i),
      key: `star-id-${i}`,
      "data-testid": `star-${isPlaceHolder ? 'placeholder' : 'item'}`,
      color: getColor()
    }, props));
  }), showLabel && /*#__PURE__*/react.createElement(Label, {
    format: format,
    fontSize: fontSize
  }, formatByType[format]));
};

 false ? 0 : void 0;
Review.defaultProps = {
  count: 0,
  minCount: 0.1,
  min: 0,
  max: 5,
  score: 0,
  format: 'count',
  emptyOutline: false
};
/* harmony default export */ var review = (Review);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js


/***/ }),

/***/ 27408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ review_input; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/SelectRating/index.js + 2 modules
var SelectRating = __webpack_require__(76328);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var atoms_Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Confirm/index.js + 1 modules
var Confirm = __webpack_require__(2761);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ReviewInput/review-input.js









const inputTypes = {
  rating: SelectRating/* default */.Z,
  text: atoms_Input/* default */.Z,
  recommendation: Confirm/* default */.Z
};
const ReviewInput = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    label,
    type,
    error,
    flexDirection,
    fontSize,
    fontWeight,
    alignItems,
    textAlign,
    gap
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["label", "type", "error", "flexDirection", "fontSize", "fontWeight", "alignItems", "textAlign", "gap"]);

  const Input = inputTypes[type] || atoms_Input/* default */.Z;
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    "data-testid": "review-input-wrapper",
    flexDirection: flexDirection,
    gap: gap,
    width: 1
  }, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    "data-testid": "review-input-label",
    flex: "0.75",
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    lineHeight: "input",
    paddingY: "2"
  }, label), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    gap: "2",
    flex: "1",
    alignItems: alignItems,
    flexDirection: ['column', ['recommendation', 'rating'].includes(type) ? 'row' : 'column'],
    "data-testid": "review-input-container"
  }, /*#__PURE__*/react.createElement(Input, (0,esm_extends/* default */.Z)({
    ref: ref
  }, !['rating', 'recommendation'].includes(type) && {
    hasError: !!error
  }, type === 'textarea' && {
    multiline: true
  }, props)), error && /*#__PURE__*/react.createElement(Text/* default */.Z, {
    color: "error.base"
  }, error)));
});
ReviewInput.defaultProps = {
  error: null,
  flexDirection: null,
  fontSize: 2,
  fontWeight: 'regular',
  gap: 30,
  label: null,
  textAlign: 'right',
  alignItems: 'start'
};
 false ? 0 : void 0;
ReviewInput.displayName = 'ReviewInput';
/* harmony default export */ var review_input = (ReviewInput);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ReviewInput/index.js


/***/ }),

/***/ 66457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "W1": function() { return /* binding */ SearchIcon; },
/* harmony export */   "xJ": function() { return /* binding */ ContainerInput; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31461);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99673);
/* harmony import */ var _magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55403);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68054);
/* harmony import */ var _magalu_stereo_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34490);
/* harmony import */ var _atoms_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19527);






const SearchIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_magalu_stereo_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .Search */ .olm)`
  fill: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('palette.primary.base')};
  ${({
  desktopMode
}) => desktopMode ? styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv`
          width: 22px;
          height: 22px;
          min-width: unset;
        ` : styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv`
          width: 30px;
        `}
`;
const ContainerInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_atoms_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)`
  align-items: center;
  width: 100%;
  border: 0;
  padding: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('space.1')}px ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('space.2')}px;

  svg {
    cursor: pointer;
    min-width: 18px;
  }
  ${({
  desktopMode
}) => !desktopMode && styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv`
      background-color: ${props => (0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .getBackgroundColor */ .dF)('white')(props)};
      border-radius: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('radii.default')};
    `}
  ${({
  inputChange
}) => inputChange && styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv`
      ${({
  desktopMode
}) => desktopMode ? styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv`
              border-bottom: 1px solid ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .getBorderColor */ .kJ)('whisper')};
            ` : styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv`
              box-shadow: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('boxShadows.4')};
              z-index: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('zIndices.3')};
              border-radius: unset;
            `};
    `}
  form {
    width: 100%;
    ${({
  desktopMode
}) => !desktopMode && styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv`
        padding-left: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('space.1')}px;
      `};
  }
`;
const Input = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].input.attrs */ .ZP.input.attrs(props => Object.assign({
  fontSize: 1
}, props))`
  color: ${_ref => {
  let {
    isChanging,
    desktopMode
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, ["isChanging", "desktopMode"]);

  return (0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .getTextColor */ .uu)(isChanging && !desktopMode ? 'primary' : 'light')(props);
}};
  caret-color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .getTextColor */ .uu)('light')};
  width: 100%;
  border: 0px;
  -webkit-appearance: textfield;

  ::placeholder {
    color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .getTextColor */ .uu)('light')};
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
  ${styled_system__WEBPACK_IMPORTED_MODULE_1__/* .typography */ .cp}
`;

/***/ }),

/***/ 37222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ search_input; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/search-input.styles.js




const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs(props => Object.assign({
  bg: 'background.lighter'
}, props))`
  position: relative;
  border-radius: ${({
  desktopMode
}) => desktopMode ? 2 : 6}px;
  align-items: center;
  flex-direction: column;
  width: 100%;

  ${({
  inputChange
}) => inputChange && styled_components_browser_esm/* css */.iv`
      align-items: baseline;
      left: 0;
      z-index: ${(0,build_esm/* themeGet */.R)('zIndices.3')};

      ${({
  desktopMode
}) => desktopMode ? styled_components_browser_esm/* css */.iv`
              top: 0;
              border: 1px solid ${(0,build_esm/* getBorderColor */.kJ)('whisper')};
            ` : styled_components_browser_esm/* css */.iv`
              top: 3px;
              margin-left: -9px;
              width: calc(100% + 18px);
              border-radius: 0;
              padding: ${(0,build_esm/* themeGet */.R)('space.1')}px 0;
            `};
    `}

  ${build_esm/* color */.$_}
`;
const SearchOverlay = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  bg: 'background.overlay',
  zIndex: 1,
  top: 40,
  left: 0
}, props))`
  position: absolute;
  width: 100%;
  height: 100vh;
  opacity: 'block';
  display: 'block';
  ${build_esm/* color */.$_}
  ${index_esm/* position */.FK}
`;
const DesktopPrefix = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  fontSize: 1,
  color: 'text.scratched'
}, props))`
  ${index_esm/* typography */.cp}
  ${build_esm/* color */.$_}
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/index.js + 5 modules
var ListSuggestionItem = __webpack_require__(41065);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/AutocompleteContainer/autocomplete-container.styles.js




const autocomplete_container_styles_Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  bg: 'background.lighter',
  p: 3
}, props))`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('white')(props)};
  z-index: ${(0,build_esm/* themeGet */.R)('zIndices.2')};
  width: 100%;
  ${props => props.desktopMode && !props.isEmpty && styled_components_browser_esm/* css */.iv`
      position: absolute;
      width: inherit;
      top: 34px;
      ${build_esm/* color */.$_}
      ${index_esm/* space */.Dh}
    `}
`;
const ResultsSuggestionsContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  mb: props.isEmpty ? 0 : 3,
  zIndex: 2
}, props))`
  ${index_esm/* space */.Dh};
`;
const SuggestionTitle = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'bold',
  color: 'text.primary',
  pb: 2,
  mb: 1
}, props))`
  width: fit-content;
  border-bottom: 1px solid ${(0,build_esm/* getBorderColor */.kJ)('whisper')};

  ${build_esm/* color */.$_}
  ${index_esm/* typography */.cp}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/AutocompleteContainer/autocomplete-container.js





const AutocompleteContainer = ({
  desktopMode,
  handleClickProduct,
  handleClickSuggest,
  products,
  productsSuggestions,
  suggestions,
  suggestionsPrefix,
  term
}) => {
  return /*#__PURE__*/react.createElement(autocomplete_container_styles_Container, {
    desktopMode: desktopMode,
    isEmpty: Object.values(suggestions).length === 0 && Object.values(products).length === 0
  }, /*#__PURE__*/react.createElement(ResultsSuggestionsContainer, {
    isEmpty: Object.values(suggestions).length === 0 && Object.values(products).length === 0
  }, desktopMode && Object.values(suggestions).length > 0 && /*#__PURE__*/react.createElement(SuggestionTitle, {
    "data-testid": "suggestion-title"
  }, "sugest\xF5es de resultados"), /*#__PURE__*/react.createElement("ul", null, Object.values(suggestions).map(suggestion => /*#__PURE__*/react.createElement(ListSuggestionItem/* default */.Z, {
    desktopMode: desktopMode,
    prefix: suggestionsPrefix,
    term: term,
    key: suggestion.count,
    item: suggestion,
    onSearchSubmit: e => handleClickSuggest(e, suggestion == null ? void 0 : suggestion.term, 'clickSuggestion')
  })))), desktopMode && productsSuggestions && Object.values(productsSuggestions).length > 0 && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(SuggestionTitle, {
    "data-testid": "suggestion-title"
  }, "sugest\xF5es de produtos"), /*#__PURE__*/react.createElement("ul", null, Object.values(productsSuggestions).map(productSuggestion => /*#__PURE__*/react.createElement(ListSuggestionItem/* default */.Z, {
    desktopMode: desktopMode,
    term: term,
    key: productSuggestion.id,
    item: productSuggestion,
    borderBottom: true,
    onSearchSubmit: e => handleClickProduct(e, productSuggestion)
  })))));
};

 false ? 0 : void 0;
AutocompleteContainer.defaultProps = {
  autocompleteRef: {},
  desktopMode: false,
  products: [],
  suggestions: [],
  suggestionsPrefix: '',
  term: ''
};
/* harmony default export */ var autocomplete_container = (AutocompleteContainer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/AutocompleteContainer/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/TopTermsContainer/top-terms-container.styles.js




const top_terms_container_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  bg: 'background.lighter',
  p: 2,
  zIndex: 2
}, props))`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('white')(props)};
  z-index: ${(0,build_esm/* themeGet */.R)('zIndices.2')};
  width: 100%;
  ${props => props.desktopMode && !props.isEmpty && styled_components_browser_esm/* css */.iv`
      position: absolute;
      width: inherit;
      top: 34px;
      ${build_esm/* color */.$_}
      ${index_esm/* space */.Dh}
    `}
`;
const ResultsTermsContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  mb: props.isEmpty ? 0 : 3
}, props))`
  ${index_esm/* space */.Dh};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/TopTermsContainer/top-terms-container.js






const listIndexIcon = index => {
  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    bg: "background.primary",
    p: 2,
    borderRadius: 2
  }, index);
};

const TopTermsContainer = ({
  desktopMode,
  list,
  label,
  handleClickTopTerm
}) => {
  return /*#__PURE__*/react.createElement(top_terms_container_styles_Container, {
    "data-testid": "top-terms-container",
    desktopMode: desktopMode,
    isEmpty: list.length === 0
  }, /*#__PURE__*/react.createElement(ResultsTermsContainer, {
    isEmpty: list.length === 0
  }, list.length > 0 && /*#__PURE__*/react.createElement(molecules/* List */.aV, {
    divided: true
  }, /*#__PURE__*/react.createElement(molecules/* List.Header */.aV.Header, {
    "data-testid": "top-terms-header",
    fontSize: 1,
    fontWeight: "bold",
    color: "text.scratched",
    pb: 2,
    mb: 1
  }, label), list.map((topTerm, index) => /*#__PURE__*/react.createElement(molecules/* List.Item */.aV.Item, {
    "data-testid": "top-terms-item",
    key: `top-term-${index}`,
    startIcon: listIndexIcon(index + 1),
    fill: "red",
    onClick: e => handleClickTopTerm(e, topTerm),
    fontSize: 2
  }, topTerm.term)))));
};

 false ? 0 : void 0;
TopTermsContainer.defaultProps = {
  desktopMode: false
};
/* harmony default export */ var top_terms_container = (TopTermsContainer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/TopTermsContainer/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/index.js + 2 modules
var HiddenLabel = __webpack_require__(33055);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/InputContainer/input-container.styles.js
var input_container_styles = __webpack_require__(66457);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/InputContainer/input-container.js








const InputContainer = _ref => {
  let {
    desktopMode,
    handleClear,
    handleClose,
    handleOpen,
    handleSubmit,
    handleType,
    inputChange,
    handleClickEvent,
    keypressHandler,
    term,
    disableClear
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["desktopMode", "handleClear", "handleClose", "handleOpen", "handleSubmit", "handleType", "inputChange", "handleClickEvent", "keypressHandler", "term", "disableClear"]);

  return /*#__PURE__*/react.createElement(input_container_styles/* ContainerInput */.xJ, {
    "data-testid": "input-container",
    inputChange: inputChange,
    desktopMode: desktopMode
  }, !desktopMode && inputChange && /*#__PURE__*/react.createElement(esm/* ArrowBack */.xhZ, {
    color: "#818181",
    "data-testid": "arrow-back",
    onClick: handleClose
  }), /*#__PURE__*/react.createElement("form", {
    "data-testid": "form-search",
    onSubmit: e => handleSubmit(e, 'submit'),
    autoComplete: "off"
  }, /*#__PURE__*/react.createElement(HiddenLabel/* default */.Z, {
    text: "Procure no magalu",
    htmlFor: "input-search"
  }), /*#__PURE__*/react.createElement(input_container_styles/* Input */.II, (0,esm_extends/* default */.Z)({}, props, {
    onChange: e => handleType(e),
    onClick: handleOpen,
    value: term,
    id: "input-search",
    type: "search",
    isChanging: inputChange,
    desktopMode: desktopMode,
    onKeyDown: keypressHandler,
    "data-testid": "input-search",
    accessKey: "s"
  }))), (!disableClear || !desktopMode && inputChange && term !== '') && /*#__PURE__*/react.createElement(esm/* CloseCircleFilled */.B86, {
    "data-testid": "close-circle",
    color: "#818181",
    onClick: handleClear,
    width: 17,
    height: 17,
    margin: !disableClear ? '0 16px' : 'unset',
    marginRight: 2,
    marginBottom: '1px'
  }), /*#__PURE__*/react.createElement(input_container_styles/* SearchIcon */.W1, {
    "aria-label": "Buscar produto",
    "data-testid": "search-submit",
    desktopMode: desktopMode,
    onClick: e => {
      handleSubmit(e, 'icon');
      handleClickEvent();
    },
    role: "button",
    tabIndex: "0"
  }));
};

 false ? 0 : void 0;
InputContainer.defaultProps = {
  desktopMode: false,
  inputChange: false,
  disableClear: true,
  term: ''
};
/* harmony default export */ var input_container = (InputContainer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/InputContainer/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/search-input.js











const conditionalInputChange = (desktopMode, term) => {
  return desktopMode && term === '';
};

const getSuggestionsPrefix = desktopMode => desktopMode ? /*#__PURE__*/react.createElement(DesktopPrefix, null, "+") : /*#__PURE__*/react.createElement(esm/* Search */.olm, {
  color: "#818181"
});

const escKeypressHandler = (event, handler) => {
  // ESC event
  if (event.keyCode === 27) {
    handler();
  }
};

const SearchInput = _ref => {
  let {
    onSearch,
    onTypeChange,
    onInputClear,
    onInputClose,
    onInputOpen,
    onSuggestItemClick,
    onProductItemClick,
    onTopTermItemClick,
    initialValue,
    onClickSearchEvent,
    list,
    products,
    desktopMode,
    topTerms
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onSearch", "onTypeChange", "onInputClear", "onInputClose", "onInputOpen", "onSuggestItemClick", "onProductItemClick", "onTopTermItemClick", "initialValue", "onClickSearchEvent", "list", "products", "desktopMode", "topTerms"]);

  const [term, setTerm] = (0,react.useState)(initialValue);
  const [inputChange, setInputChange] = (0,react.useState)(false);
  const [suggestions, setSuggestions] = (0,react.useState)(list);
  const [productsSuggestions, setProductsSuggestions] = (0,react.useState)(products);
  const suggestionsPrefix = getSuggestionsPrefix(desktopMode);
  const {
    shouldDisplay: shouldDisplayTopTerms,
    list: topTermsList
  } = topTerms;
  (0,react.useEffect)(() => {
    setSuggestions(list || []);
  }, [list]);
  (0,react.useEffect)(() => {
    setProductsSuggestions(products);
  }, [products]);
  (0,react.useEffect)(() => {
    setTerm(initialValue);
  }, [initialValue]);

  const handleSubmit = (e, from) => {
    if (!term.trim()) {
      e.preventDefault();
      return;
    }

    setInputChange(false);
    onSearch(e, term, from);
  };

  const handleType = e => {
    const newTerm = e.target.value; // Allows autocomplete container to keep open for mobile mode only

    setInputChange(!conditionalInputChange(desktopMode, newTerm));
    setTerm(newTerm);
    onTypeChange(newTerm);
  };

  const handleClickSuggest = (e, suggest, from) => {
    onSuggestItemClick(suggest, from);
    setInputChange(false);
    setTerm(suggest);
    onSearch(e, suggest, from);
  };

  const handleClickTopTerm = (e, topTerm) => {
    const {
      term: newTerm
    } = topTerm;
    onTopTermItemClick(topTerm);
    setInputChange(false);
    setTerm(newTerm);
    onSearch(e, newTerm);
  };

  const handleClickProduct = (e, product) => {
    setInputChange(false);
    setTerm('');
    onProductItemClick(e, product);
  };

  const handleClear = () => {
    onInputClear();
    setTerm('');
  };

  const handleClose = () => {
    onInputClose();
    setInputChange(false);
  };

  const handleOpen = () => {
    onInputOpen();
    setInputChange(true);
  }; // Set hook to close autocomplete if user click outside of it
  // https://usehooks.com/useOnClickOutside/


  const autocompleteRef = (0,react.useRef)();
  (0,utils/* useOnClickOutside */.t$)(autocompleteRef, () => {
    if (inputChange || shouldDisplayTopTerms) handleClose(); // send event close only if the autocomplete is opened
  });

  const renderAutocompleteContainer = () => {
    return inputChange && list ? /*#__PURE__*/react.createElement(autocomplete_container, {
      desktopMode: desktopMode,
      handleClickProduct: handleClickProduct,
      handleClickSuggest: handleClickSuggest,
      handleClose: handleClose,
      products: products,
      productsSuggestions: productsSuggestions,
      suggestions: suggestions,
      suggestionsPrefix: suggestionsPrefix,
      term: term
    }) : /*#__PURE__*/react.createElement(react.Fragment, null);
  };

  const renderTopTermsContainer = () => {
    return topTermsList ? /*#__PURE__*/react.createElement(top_terms_container, (0,esm_extends/* default */.Z)({}, topTerms, {
      desktopMode: desktopMode,
      handleClickTopTerm: handleClickTopTerm
    })) : /*#__PURE__*/react.createElement(react.Fragment, null);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Container, {
    inputChange: inputChange,
    desktopMode: desktopMode,
    ref: autocompleteRef,
    id: "search-container",
    "data-testid": "search-input-container"
  }, /*#__PURE__*/react.createElement(input_container, (0,esm_extends/* default */.Z)({
    desktopMode: desktopMode,
    handleClear: handleClear,
    handleClose: handleClose,
    handleClickEvent: onClickSearchEvent,
    handleOpen: handleOpen,
    handleSubmit: handleSubmit,
    handleType: handleType,
    inputChange: inputChange,
    keypressHandler: e => escKeypressHandler(e, handleClose),
    term: term
  }, props)), shouldDisplayTopTerms ? renderTopTermsContainer() : renderAutocompleteContainer(), !desktopMode && inputChange && /*#__PURE__*/react.createElement(SearchOverlay, {
    "data-testid": "input-overlay",
    onTouchMove: handleClose,
    onClick: handleClose
  })));
};

 false ? 0 : void 0;
SearchInput.defaultProps = {
  list: [],
  products: [],
  initialValue: '',
  onInputClear: () => {},
  onSuggestItemClick: () => {},
  onProductItemClick: () => {},
  onTopTermItemClick: () => {},
  onInputClose: () => {},
  onInputOpen: () => {},
  desktopMode: false,
  topTerms: {
    shouldDisplay: false,
    label: 'Mais Buscados',
    list: []
  }
};
/* harmony default export */ var search_input = (SearchInput);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/index.js


/***/ }),

/***/ 57991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ shipping_button; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShippingButton/shipping-button.styles.js






const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  bg: 'background.base',
  borderRadius: 'medium'
}, props))`
  position: relative;
  padding: 16px 12px;
  align-items: center;
  cursor: pointer;

  ${index_esm/* border */.Cg}
  ${build_esm/* color */.$_}
`;
const Disabled = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  bg: 'background.base',
  borderRadius: 'medium',
  zIndex: 4
}, props))`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  display: flex;
  justify-content: center;
  align-items: center;

  ${index_esm/* border */.Cg}
  ${build_esm/* color */.$_}
`;
const LoadingIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* AnimatedLoadingColorful2 */.hq5).attrs({
  width: 24,
  height: 24
})``;
const PinIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Pin */.lO8)`
  margin-right: 12px;
  flex-grow: 0;
  width: 18px;
  height: 18px;
  ${build_esm/* color */.$_}
`;
const Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  flex-grow: 1;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
`;
const ChangeLink = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  flex-grow: 0;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,build_esm/* getPaletteColor */.ow)('primary.base')(props)};
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShippingButton/shipping-button.js







const ShippingButton = _ref => {
  let {
    placeholder,
    changeLabel,
    actionLabel,
    disabled,
    done,
    loading,
    onClick,
    location,
    maxCityLength
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["placeholder", "changeLabel", "actionLabel", "disabled", "done", "loading", "onClick", "location", "maxCityLength"]);

  const locationText = location && Object.keys(location).length ? (0,utils/* locationText */.RZ)(Object.assign({}, location, {
    maxCityLength,
    includeAddress: false
  })) : '';
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    onClick: loading || disabled ? () => {} : onClick,
    "data-testid": "shipping-button"
  }), (loading || disabled) && /*#__PURE__*/react.createElement(Disabled, {
    "data-testid": "shipping-disabled"
  }, loading && /*#__PURE__*/react.createElement(LoadingIcon, null)), /*#__PURE__*/react.createElement(PinIcon, {
    fill: "primary.base"
  }), /*#__PURE__*/react.createElement(Label, {
    as: "span"
  }, locationText || placeholder), !!locationText && /*#__PURE__*/react.createElement(ChangeLink, {
    as: "span"
  }, done ? changeLabel : actionLabel));
};

ShippingButton.defaultProps = {
  placeholder: 'Calcular frete e prazo',
  changeLabel: 'alterar',
  actionLabel: 'calcular',
  disabled: false,
  loading: false,
  done: false,
  onClick: () => {},
  location: {},
  maxCityLength: 24
};
 false ? 0 : void 0;
/* harmony default export */ var shipping_button = (ShippingButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShippingButton/index.js


/***/ }),

/***/ 15185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ shopping_bag_button; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShoppingBagButton/shopping-bag-button.styles.js

const IconContainer = styled_components_browser_esm/* default.div */.ZP.div`
  & > svg {
    transform: scale(2.5);
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShoppingBagButton/shopping-bag-button.js






const ShoppingBagButton = ({
  amount,
  nullable,
  truncateAmountThreshold,
  backgroundColor,
  fontColor = '#fff',
  counterColor = '#58c22e',
  iconColor = '#fff',
  onClick
}) => /*#__PURE__*/react.createElement(atoms/* NumberedButton */.fG, {
  amount,
  nullable,
  truncateAmountThreshold,
  backgroundColor,
  counterColor,
  fontColor,
  onClick
}, /*#__PURE__*/react.createElement(IconContainer, null, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
  name: "ShoppingBag",
  color: iconColor
})));

 false ? 0 : void 0;
ShoppingBagButton.defaultProps = {
  amount: 0,
  onClick: () => {},
  nullable: true
};
/* harmony default export */ var shopping_bag_button = (ShoppingBagButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShoppingBagButton/index.js


/***/ }),

/***/ 51382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ social_share; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SocialShare/social-share.styles.js


const Container = styled_components_browser_esm/* default.a */.ZP.a`
  position: relative;
  cursor: pointer;
`;
const Content = styled_components_browser_esm/* default.div */.ZP.div`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('lighter')(props)};
  border-radius: 6px;
  padding: 10px;
  width: 190px;
  display: ${props => props.open ? 'flex' : 'none'};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  top: 110%;
  right: 0px;
  position: absolute;
  z-index: ${props => (0,build_esm/* themeGet */.R)('zIndices.0')(props)};
  box-shadow: ${props => (0,build_esm/* themeGet */.R)('elevations.4')(props)};
`;
const Circle = styled_components_browser_esm/* default.a */.ZP.a`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('primary')(props)};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > svg {
    width: 16px;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SocialShare/social-share.js







function SocialShare(_ref) {
  let {
    socialItems,
    onItemClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["socialItems", "onItemClick"]);

  const [open, setOpen] = (0,react.useState)(false);

  const handleToggleOpen = () => {
    setOpen(!open);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      handleToggleOpen();
    }
  };

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    "aria-label": "Compartilhar",
    role: "button",
    "aria-haspopup": "true",
    "aria-expanded": open,
    onClick: handleToggleOpen,
    onKeyDown: handleKeyDown,
    tabIndex: "0"
  }), /*#__PURE__*/react.createElement(esm/* Share */.mBz, {
    height: "24",
    color: "#818181",
    "data-testid": "social-share",
    "aria-hidden": "true"
  }), /*#__PURE__*/react.createElement(Content, {
    open: open,
    "data-testid": "social-content"
  }, socialItems.map(({
    title,
    url,
    Icon
  }) => /*#__PURE__*/react.createElement(Circle, {
    key: title,
    href: url,
    target: "_blank",
    onClick: e => onItemClick(e, title),
    "aria-label": title
  }, Icon))));
}

 false ? 0 : void 0;
SocialShare.defaultProps = {
  socialItems: [],
  onItemClick: () => {}
};
/* harmony default export */ var social_share = (SocialShare);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SocialShare/index.js


/***/ }),

/***/ 50919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ table_factsheet; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TableFactsheet/table-factsheet.styles.js



const Table = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  forwardedAs: 'table'
}, props))`
  list-style: none;

  tbody > tr > td {
    padding: 5px;
  }
`;
const TableTitle = styled_components_browser_esm/* default.td */.ZP.td`
  font-weight: bold;
  color: ${props => (0,esm/* themeGet */.R)('colors.darkSilver')(props)};
  background: ${props => (0,esm/* getBackgroundColor */.dF)('base')(props)};
  display: ${({
  layout
}) => layout === 'horizontal' ? 'table-cell' : 'list-item'};
  width: ${({
  layout
}) => layout === 'horizontal' ? '20%' : '100%'};
`;
const TableContainer = styled_components_browser_esm/* default.td */.ZP.td`
  display: list-item;
  width: 100%;
  padding: 5px;
`;
const Name = styled_components_browser_esm/* default.td */.ZP.td`
  width: 40%;
`;
const InnerTable = styled_components_browser_esm/* default.table */.ZP.table`
  width: 100%;
  td:first-child {
    display: table-cell;
  }
  tr {
    display: table-row;
    vertical-align: middle;
  }
`;
const InnerTableLink = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU)`
  text-decoration: underline;
  font-size: inherit;

  &:hover {
    color: ${props => (0,esm/* getTextColor */.uu)('primary')(props)};
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TableFactsheet/table-factsheet.js





function TableFactsheet(_ref) {
  var _data$elements;

  let {
    data,
    layout
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "layout"]);

  const subItemBuild = subItem => {
    return subItem.isLink ? /*#__PURE__*/react.createElement(InnerTableLink, {
      href: subItem.path
    }, subItem == null ? void 0 : subItem.value) : subItem == null ? void 0 : subItem.value;
  };

  return /*#__PURE__*/react.createElement(Table, props, /*#__PURE__*/react.createElement("tbody", null, data == null ? void 0 : (_data$elements = data.elements) == null ? void 0 : _data$elements.map(item => {
    var _item$elements;

    return /*#__PURE__*/react.createElement("tr", {
      key: item.slug
    }, /*#__PURE__*/react.createElement(TableTitle, {
      layout: layout
    }, item.keyName), /*#__PURE__*/react.createElement(TableContainer, null, /*#__PURE__*/react.createElement(InnerTable, null, /*#__PURE__*/react.createElement("tbody", null, item == null ? void 0 : (_item$elements = item.elements) == null ? void 0 : _item$elements.map((subItem, idx) => /*#__PURE__*/react.createElement("tr", {
      key: idx
    }, subItem.keyName && /*#__PURE__*/react.createElement(Name, null, subItem.keyName), /*#__PURE__*/react.createElement("td", null, subItemBuild(subItem))))))));
  })));
}

 false ? 0 : void 0;
TableFactsheet.defaultProps = {
  color: 'text.base',
  fontSize: 0,
  layout: 'vertical'
};
/* harmony default export */ var table_factsheet = (TableFactsheet);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TableFactsheet/index.js


/***/ }),

/***/ 62458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ tag_coupon; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TagCoupon/tag-coupon.styles.js




const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs(() => ({
  fontSize: 0,
  borderRadius: 4,
  fontWeight: '600',
  padding: '2px 4px'
}))`
  width: fit-content;
  align-items: center;
  background-color: ${(0,esm/* getBackgroundColor */.dF)('limeGreen')};
`;
const Icon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$).attrs(() => ({}))`
  color: ${(0,esm/* getTextColor */.uu)('dark')};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TagCoupon/tag-coupon.js








function TagCoupon(_ref) {
  let {
    tags,
    showIcon
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["tags", "showIcon"]);

  const discount = (0,utils/* formatDiscountMessage */.Qd)(tags);
  return discount && /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    "data-testid": "productCard-coupon",
    "aria-label": `Cupom de ${discount.toLowerCase()}`
  }), showIcon && /*#__PURE__*/react.createElement(Icon, {
    "data-testid": "coupon-icon",
    color: "dark",
    name: "LocalActivity",
    mr: 1,
    height: 12,
    width: 12
  }), /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "dark"
  }, "Cupom ", discount));
}

TagCoupon.defaultProps = {
  tags: {},
  showIcon: true
};
 false ? 0 : void 0;
/* harmony default export */ var tag_coupon = (TagCoupon);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TagCoupon/index.js


/***/ }),

/***/ 93168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ toolbar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Toolbar/toolbar.styles.js



const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs({
  position: 'relative',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  width: '100%',
  px: 2
})(({
  count
}) => count === 3 && {
  '& > *:nth-child(2)': {
    position: 'absolute',
    left: '50%',
    top: '50%',
    height: '100%',
    transform: 'translate(-50%,-50%)'
  }
}, esm/* variant */.bU, esm/* scale */.bA);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Toolbar/toolbar-item.js







const ToolbarItem = _ref => {
  let {
    children,
    endIcon,
    startIcon
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "endIcon", "startIcon"]);

  const buildIcon = icon => icon && typeof icon === 'string' ? /*#__PURE__*/react.createElement(build_esm/* Icon */.JO$, {
    name: icon
  }) : icon;

  return /*#__PURE__*/react.createElement(Link/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "toolbar-item"
  }, props), buildIcon(startIcon), children, buildIcon(endIcon));
};

 false ? 0 : void 0;
ToolbarItem.defaultProps = {
  children: null,
  color: 'inherit',
  underlineOnHover: false,
  fontSize: 1,
  fontWeight: 'medium',
  gap: 1
};
/* harmony default export */ var toolbar_item = (ToolbarItem);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Toolbar/toolbar-toggle.js




const ToolbarToggle = _ref => {
  let {
    onChange
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onChange"]);

  const items = react.Children.toArray(props == null ? void 0 : props.children);
  const [index, setIndex] = (0,react.useState)(0);

  const rotateIndex = () => {
    if (index >= items.length - 1) {
      setIndex(0);
      return;
    }

    setIndex(index + 1);
  };

  (0,react.useEffect)(() => {
    const {
      props: {
        value,
        children
      }
    } = items[index];
    onChange({
      id: value,
      label: children
    });
  }, [index]);
  const children = items.map(child => /*#__PURE__*/react.cloneElement(child, {
    onClick: rotateIndex
  }));
  return children[index];
};

 false ? 0 : void 0;
/* harmony default export */ var toolbar_toggle = (ToolbarToggle);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Toolbar/toolbar.js








const Toolbar = _ref => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    count: react.Children.count(children),
    "data-testid": "toolbar"
  }, props), children);
};

 false ? 0 : void 0;
Toolbar.defaultProps = {
  children: null,
  variant: 'transparent',
  scale: 'medium'
};
Toolbar.Item = toolbar_item;
Toolbar.Toggle = toolbar_toggle;
/* harmony default export */ var toolbar = (Toolbar);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Toolbar/index.js


/***/ }),

/***/ 41237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ zipcode_input; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeInput/zipcode-input.styles.js







const Container = styled_components_browser_esm/* default.form */.ZP.form`
  position: relative;
`;
const Label = styled_components_browser_esm/* default.label */.ZP.label`
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.regular')(props)};
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.0')(props)}px;
  color: ${_ref => {
  let {
    hasError
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["hasError"]);

  return (0,esm/* getPaletteColor */.ow)(!hasError ? 'base' : 'error.base')(props);
}};
`;
const StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z)`
  border: 0;
  width: 100%;
  border-radius: 0;
  border-bottom: 1px solid;
  border-color: ${_ref2 => {
  let {
    hasError
  } = _ref2,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["hasError"]);

  return (0,esm/* getPaletteColor */.ow)(!hasError ? 'base' : 'error.base')(props);
}};
  padding: 0 0 ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
  line-height: ${props => (0,esm/* themeGet */.R)('lineHeights.input')(props)};
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.2')(props)}px;
  background-color: transparent;
  margin-top: 4px;
  &::placeholder {
    color: ${props => (0,esm/* getTextColor */.uu)('greyish')(props)};
  }
`;
const Icon = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  opacity: 0.8;
  position: absolute;
  text-align: center;
  background-color: ${props => (0,esm/* getBackgroundColor */.dF)('base')(props)};
  z-index: ${props => (0,esm/* themeGet */.R)('zIndices.0')(props)};
`;
const AnimatedLoader = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* AnimatedLoading1 */.gXO).attrs(props => ({
  color: (0,esm/* getPaletteColor */.ow)('primary')(props)
}))`
  height: 40px;
`;
const StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs(() => ({
  m: '14px 0'
}))`
  width: 70%;
`;
const StyledSpan = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(() => ({
  forwardedAs: 'span',
  color: 'text.primary',
  fontSize: 1,
  fontWeight: 'medium',
  textAlign: 'center',
  textTransform: 'uppercase'
}))`
  cursor: pointer;
  margin: 14px;
  text-transform: uppercase;
  width: 70%;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/zipcodeMask.js
var zipcodeMask = __webpack_require__(7874);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeInput/zipcode-input.js






function ZipcodeInput({
  errorText,
  hasError,
  initialValue,
  labelText,
  loading,
  locationButtonText,
  onChange,
  placeholder,
  showButton,
  inputButtonText,
  onClickLocationButton
}) {
  const [zipcode, setZipcode] = (0,react.useState)((0,zipcodeMask/* default */.Z)(initialValue));

  const handleChange = e => {
    e.preventDefault();
    const {
      value
    } = e.target;
    setZipcode((0,zipcodeMask/* default */.Z)(value));
    onChange(e, e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setZipcode((0,zipcodeMask/* default */.Z)(zipcode));
    onChange(e, zipcode);
  };

  return /*#__PURE__*/react.createElement(Container, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement(Label, {
    "data-testid": "zipcode-label",
    hasError: hasError,
    htmlFor: "zipcode"
  }, !hasError ? labelText : errorText), loading && /*#__PURE__*/react.createElement(Icon, {
    "data-testid": "zipcode-loading"
  }, /*#__PURE__*/react.createElement(AnimatedLoader, null)), /*#__PURE__*/react.createElement(StyledInput, {
    "data-testid": "zipcode-input",
    hasError: hasError,
    autoFocus: true,
    id: "zipcode",
    name: "zipcode",
    type: "text",
    inputMode: "numeric",
    maxLength: 9,
    placeholder: placeholder,
    onChange: handleChange,
    value: zipcode,
    onInput: handleChange,
    disabled: loading
  }), showButton && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    alignItems: "center",
    my: 2
  }, inputButtonText && /*#__PURE__*/react.createElement(StyledButton, {
    disabled: zipcode.length !== 9,
    "data-testid": "zipcode-button"
  }, inputButtonText), locationButtonText && /*#__PURE__*/react.createElement(StyledSpan, {
    "data-testid": "location-button",
    variation: "outline",
    boxShadow: 'none',
    onClick: onClickLocationButton
  }, locationButtonText)));
}

ZipcodeInput.defaultProps = {
  hasError: false,
  initialValue: '',
  loading: false,
  locationButtonText: undefined,
  onChange: undefined,
  showButton: false,
  inputButtonText: undefined,
  onClickLocationButton: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var zipcode_input = (ZipcodeInput);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeInput/index.js


/***/ }),

/***/ 1587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ zipcode_text; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeText/zipcode-text.styles.js




const TextContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  align-items: center;
  max-height: 44px;
  cursor: pointer;
`;
const Text = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(() => ({
  alignItems: ['center', 'flex-start', 'flex-start'],
  color: 'text.lightest',
  flexDirection: ['row', 'column', 'column'],
  fontSize: 0,
  fontWeight: 'normal'
}))``;
const Span = (0,styled_components_browser_esm/* default */.ZP)(Text).attrs(() => ({
  ml: [1, 0, 0],
  fontWeight: 'bold'
}))``;
const IconContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  ${(0,esm/* getMediaQuery */.aK)('small')} {
    max-height: 44px;
    max-width: 44px;
    width: 100%;
  }
`;
const PinIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Pin */.lO8).attrs(props => ({
  color: (0,esm/* getTextColor */.uu)('lightest')(props)
}))``;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeText/zipcode-text.js





const ZipcodeText = ({
  city,
  defaultText,
  formatter,
  iconHeight,
  iconWidth,
  state,
  text,
  zipcode
}) => {
  const textLocation = (0,utils/* locationText */.RZ)({
    formatter,
    zipCode: zipcode,
    zipCodeCity: city,
    zipCodeState: state,
    includeAddress: false
  });
  return /*#__PURE__*/react.createElement(TextContainer, null, /*#__PURE__*/react.createElement(IconContainer, null, /*#__PURE__*/react.createElement(PinIcon, {
    width: iconWidth,
    height: iconHeight
  })), /*#__PURE__*/react.createElement(Text, {
    "data-testid": "text-line"
  }, zipcode && state && city ? /*#__PURE__*/react.createElement(react.Fragment, null, text, " ", formatter ? /*#__PURE__*/react.createElement(Span, null, textLocation) : textLocation) : defaultText));
};

ZipcodeText.defaultProps = {
  city: undefined,
  formatter: undefined,
  iconHeight: undefined,
  iconWidth: undefined,
  state: undefined,
  zipcode: undefined
};
 false ? 0 : void 0;
/* harmony default export */ var zipcode_text = (ZipcodeText);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeText/index.js


/***/ }),

/***/ 39146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iG": function() { return /* reexport */ AddWishlistButton/* default */.Z; },
  "QP": function() { return /* reexport */ AlertText/* default */.Z; },
  "Ct": function() { return /* reexport */ Badge/* default */.Z; },
  "lr": function() { return /* reexport */ Carousel/* default */.Z; },
  "F7": function() { return /* reexport */ CouponCodeCopy/* default */.Z; },
  "g0": function() { return /* reexport */ DynamicText/* default */.Z; },
  "HS": function() { return /* reexport */ FilterInput/* default */.Z; },
  "L2": function() { return /* reexport */ FilterItem/* default */.Z; },
  "pl": function() { return /* reexport */ horizontal_links; },
  "hU": function() { return /* reexport */ IconButton/* default */.Z; },
  "aV": function() { return /* reexport */ List/* default */.Z; },
  "RG": function() { return /* reexport */ login_menu; },
  "mY": function() { return /* reexport */ loyalty; },
  "dV": function() { return /* reexport */ OfferTimer/* default */.Z; },
  "tA": function() { return /* reexport */ Price/* default */.Z; },
  "MS": function() { return /* reexport */ PriceRange/* default */.Z; },
  "lF": function() { return /* reexport */ product_shipping; },
  "Ee": function() { return /* reexport */ RadioGroup/* default */.Z; },
  "me": function() { return /* reexport */ RatingLine/* default */.Z; },
  "Cq": function() { return /* reexport */ Review/* default */.Z; },
  "qr": function() { return /* reexport */ ReviewInput/* default */.Z; },
  "Mj": function() { return /* reexport */ SearchInput/* default */.Z; },
  "KI": function() { return /* reexport */ shipping_item; },
  "kV": function() { return /* reexport */ ShoppingBagButton/* default */.Z; },
  "ok": function() { return /* reexport */ subscription_form; },
  "rE": function() { return /* reexport */ TagCoupon/* default */.Z; },
  "Rs": function() { return /* reexport */ wishlist_counter_button; },
  "YQ": function() { return /* reexport */ ZipcodeText/* default */.Z; }
});

// UNUSED EXPORTS: Avatar, BackToTop, Breadcrumb, CardanAlterButtons, CardanCarInfo, Confirm, CopyToClipBoard, Counter, DeliveryFilter, HiddenLabel, HotLinks, Installment, LabelScore, ListDisplayType, ListSuggestionItem, MediaReviewCard, MessageBox, Pagination, PaginationItem, PaymentMethods, ShippingButton, SocialShare, TableFactsheet, Testimonials, ZipcodeInput, useAlert

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Alert/index.js + 3 modules
var Alert = __webpack_require__(33309);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js + 2 modules
var AlertText = __webpack_require__(52337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/OfferTimer/index.js + 2 modules
var OfferTimer = __webpack_require__(3310);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/index.js + 2 modules
var Avatar = __webpack_require__(78045);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/BackToTop/index.js + 2 modules
var BackToTop = __webpack_require__(96504);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Badge/index.js + 2 modules
var Badge = __webpack_require__(98460);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Breadcrumb/index.js + 2 modules
var Breadcrumb = __webpack_require__(67619);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanAlterButtons/index.js + 2 modules
var CardanAlterButtons = __webpack_require__(94296);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanCarInfo/index.js + 2 modules
var CardanCarInfo = __webpack_require__(72720);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Confirm/index.js + 1 modules
var Confirm = __webpack_require__(2761);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Counter/index.js + 2 modules
var Counter = __webpack_require__(84022);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/index.js + 2 modules
var CopyToClipboard = __webpack_require__(12241);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CouponCodeCopy/index.js + 2 modules
var CouponCodeCopy = __webpack_require__(57142);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DeliveryFilter/index.js + 2 modules
var DeliveryFilter = __webpack_require__(18822);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DynamicText/index.js + 2 modules
var DynamicText = __webpack_require__(16618);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/index.js + 2 modules
var FilterInput = __webpack_require__(99554);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterItem/index.js + 2 modules
var FilterItem = __webpack_require__(1729);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/index.js + 2 modules
var HiddenLabel = __webpack_require__(33055);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HotLinks/index.js + 2 modules
var HotLinks = __webpack_require__(2490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/IconButton/index.js + 2 modules
var IconButton = __webpack_require__(15309);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Installment/index.js + 2 modules
var Installment = __webpack_require__(97769);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LabelScore/label-score.styles.js



const Container = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const byType = {
  normal: styled_components_browser_esm/* css */.iv`
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  `,
  big: styled_components_browser_esm/* css */.iv`
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.4')(props)}px;
    font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  `
};
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  margin-bottom: 5px;

  ${props => byType[props.type]}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LabelScore/label-score.js





function LabelScore({
  label,
  type
}) {
  const stars = Array.from(Array(5).keys());
  const size = type === 'normal' ? '30px' : '40px';
  return /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(Title, {
    type: type,
    "data-testid": "title"
  }, label), /*#__PURE__*/react.createElement("ul", null, stars.map(i => /*#__PURE__*/react.createElement(esm/* Star */.Uxw, {
    key: `star-${i}`,
    color: "#FFCC03",
    width: size,
    height: size
  }))));
}

LabelScore.defaultProps = {
  size: '30px',
  type: 'normal'
};
 false ? 0 : void 0;
/* harmony default export */ var label_score = ((/* unused pure expression or super */ null && (LabelScore)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LabelScore/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListDisplayType/index.js + 2 modules
var ListDisplayType = __webpack_require__(33359);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListSuggestionItem/index.js + 5 modules
var ListSuggestionItem = __webpack_require__(41065);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var stereo_ui_utils_build_esm = __webpack_require__(71180);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Loyalty/loyalty.styles.js


const LoyaltyContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.color || '#fff'};
  border-radius: 6px;
  padding: 3px 5px;
  cursor: default;
`;
const TransparentButton = styled_components_browser_esm/* default.button */.ZP.button`
  background: none;
  border: none;
  cursor: pointer;
  line-height: 0px;
`;
const LoyaltyText = styled_components_browser_esm/* default.p */.ZP.p`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  color: ${props => props.color || '#fff'};
  margin: 0 5px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Loyalty/loyalty.js






const Loyalty = ({
  value,
  color,
  icon,
  textColor,
  onClick,
  hasInfo
}) => {
  return /*#__PURE__*/react.createElement(LoyaltyContainer, {
    color: color,
    "data-testid": "loyalty",
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
    }
  }, icon && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    "data-testid": `${icon}Icon`,
    name: icon,
    width: "12px",
    height: "12px",
    color: "#fff"
  }), /*#__PURE__*/react.createElement(LoyaltyText, {
    color: textColor,
    "data-testid": "loyalty-value"
  }, (0,stereo_ui_utils_build_esm/* currencyFormatter */.oB)({
    value: parseFloat(value)
  })), hasInfo && /*#__PURE__*/react.createElement(TransparentButton, {
    "data-testid": "loyalty-info-button",
    onClick: onClick
  }, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "HelpOutline",
    color: "none",
    width: "12px",
    height: "12px"
  })));
};

Loyalty.defaultProps = {
  hasInfo: false,
  color: undefined
};
 false ? 0 : void 0;
/* harmony default export */ var loyalty = (Loyalty);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Loyalty/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MessageBox/index.js + 2 modules
var MessageBox = __webpack_require__(28982);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Pagination/index.js + 3 modules
var Pagination = __webpack_require__(19620);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaginationItem/index.js + 2 modules
var PaginationItem = __webpack_require__(81484);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/index.js + 5 modules
var PaymentMethods = __webpack_require__(563);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/index.js + 9 modules
var Price = __webpack_require__(23458);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PriceRange/index.js + 2 modules
var PriceRange = __webpack_require__(58125);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RatingLine/index.js + 2 modules
var RatingLine = __webpack_require__(11151);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/index.js + 10 modules
var SearchInput = __webpack_require__(37222);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShippingButton/index.js + 2 modules
var ShippingButton = __webpack_require__(57991);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/isInternationalPrice.js
var isInternationalPrice = __webpack_require__(97728);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShippingItem/shipping-item.styles.js






const deliveryIconDefault = styled_components_browser_esm/* css */.iv`
  margin-right: 12px;
  flex-grow: 0;
  width: 30px;
  height: 30px;
`;
const shipping_item_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  padding: 16px 12px;
  align-items: center;
`;
const FastDeliveryIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* FastDelivery */._Ps)`
  ${deliveryIconDefault}
  ${build_esm/* color */.$_}
`;
const PickupStoreIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* PickupStore */.XqY)`
  ${deliveryIconDefault}
  ${build_esm/* color */.$_}
`;
const Delivery1hIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Delivery1h */.Gb7)`
  ${deliveryIconDefault}
  ${build_esm/* color */.$_}
`;
const DeliveryRTomorrowIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* DeliveryRTomorrow */.f9j)`
  ${deliveryIconDefault}
  ${build_esm/* color */.$_}
`;
const Delivery24hIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Delivery24h */.Ju)`
  ${deliveryIconDefault}
  ${build_esm/* color */.$_}
`;
const ExpressDeliveryIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* ExpressDelivery */.oFb)`
  ${deliveryIconDefault}
  ${build_esm/* color */.$_}
  min-width: 30px;
`;
const AirPlaneIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Airplane */.gbh)`
  ${deliveryIconDefault}
  ${build_esm/* color */.$_}
  min-width: 30px;
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  flex: 4;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.big')(props)};
`;
const Complement = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  display: block;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  padding-right: 15px;
`;
const shipping_item_styles_Price = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  flex: 1;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  text-align: center;
  color: ${_ref => {
  let {
    free
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["free"]);

  return free ? (0,build_esm/* getPaletteColor */.ow)('secondary.base')(props) : (0,build_esm/* getPaletteColor */.ow)('text.base')(props);
}};
  display: contents;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShippingItem/shipping-item.js








const ShippingItem = _ref => {
  let {
    complement,
    description,
    price,
    currency,
    time,
    type,
    unit,
    freeShippingLabel
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["complement", "description", "price", "currency", "time", "type", "unit", "freeShippingLabel"]);

  const renderDeliveryTime = fill => {
    const showInternationalShipping = (0,isInternationalPrice/* default */.Z)({
      currency
    });
    if (showInternationalShipping) return /*#__PURE__*/react.createElement(AirPlaneIcon, {
      fill: fill
    });
    if (unit === 'hours' && time <= 2) return /*#__PURE__*/react.createElement(ExpressDeliveryIcon, {
      fill: fill
    });
    if (unit === 'days' && time === 0) return /*#__PURE__*/react.createElement(Delivery1hIcon, {
      fill: fill
    });
    if (unit === 'days' && time === 1) return /*#__PURE__*/react.createElement(DeliveryRTomorrowIcon, {
      fill: fill
    });
    if (unit === 'working_days' && time === 1) return /*#__PURE__*/react.createElement(Delivery24hIcon, {
      fill: fill
    });
    return !showInternationalShipping && /*#__PURE__*/react.createElement(FastDeliveryIcon, {
      fill: fill
    });
  };

  return /*#__PURE__*/react.createElement(shipping_item_styles_Container, (0,esm_extends/* default */.Z)({
    "data-testid": "shipping-item"
  }, props), ['store_pickup', 'pickup_point'].includes(type) && /*#__PURE__*/react.createElement(PickupStoreIcon, {
    fill: "background.dark"
  }) || renderDeliveryTime('background.dark'), /*#__PURE__*/react.createElement(Description, null, description, /*#__PURE__*/react.createElement(Complement, {
    as: "span"
  }, complement)), !!Number(price) && /*#__PURE__*/react.createElement(shipping_item_styles_Price, null, (0,stereo_ui_utils_build_esm/* currencyFormatter */.oB)({
    value: price
  })) || /*#__PURE__*/react.createElement(shipping_item_styles_Price, {
    free: true
  }, freeShippingLabel));
};

ShippingItem.defaultProps = {
  freeShippingLabel: 'Frete Grátis',
  unit: ''
};
 false ? 0 : void 0;
/* harmony default export */ var shipping_item = (ShippingItem);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShippingItem/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShoppingBagButton/index.js + 2 modules
var ShoppingBagButton = __webpack_require__(15185);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TableFactsheet/index.js + 2 modules
var TableFactsheet = __webpack_require__(50919);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Testimonials/testimonials.styles.js


const Row = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  grid-column-gap: 5px;
  grid-row-gap: 8px;
  grid-template-columns: repeat(3, 1fr);
`;
const TextName = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
  fontWeight: 'bold',
  fontSize: 3,
  color: 'primary',
  mb: 2
})``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Testimonials/testimonials.js







const Testimonials = ({
  recommends,
  title
}) => {
  return /*#__PURE__*/react.createElement(Box/* default */.Z, null, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    fontSize: 4,
    mb: 4
  }, title), /*#__PURE__*/react.createElement(Row, null, recommends.map((item, index) => {
    return /*#__PURE__*/react.createElement(Box/* default */.Z, {
      key: index
    }, /*#__PURE__*/react.createElement(TextName, null, item.name), /*#__PURE__*/react.createElement(Text/* default */.Z, null, item.city), /*#__PURE__*/react.createElement(Review/* default */.Z, {
      score: item.score
    }), /*#__PURE__*/react.createElement(Text/* default */.Z, {
      lineHeight: 1
    }, item.text));
  })));
};

Testimonials.defaultProps = {
  recommends: [],
  title: ''
};
 false ? 0 : void 0;
/* harmony default export */ var testimonials = ((/* unused pure expression or super */ null && (Testimonials)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Testimonials/index.js

// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/login-menu.styles.js


const login_menu_styles_Container = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  ${index_esm/* color */.$_}
  ${index_esm/* flexbox */.GQ}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/subcomponents/UnsignedUserState/unsigned-user-state.styles.js




const unsigned_user_state_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)``;
const Message = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(props => Object.assign({
  color: 'text.white',
  fontWeight: 'bold',
  fontSize: 0
}, props))`
  ${build_esm/* color */.$_}
`;
const StyledLink = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(props => Object.assign({
  color: 'text.white',
  fontSize: 0,
  p: 0
}, props))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/subcomponents/UnsignedUserState/unsigned-user-state.js






const UnsignedUserState = _ref => {
  let {
    message: {
      text: messageText = ''
    } = {},
    loginLink: {
      text: loginLinkText = 'Entre ou cadastre-se',
      url: loginLinkURL = '#'
    } = {},
    handleUnsignedClick
  } = _ref,
      messageStyledProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref.message, ["text"]),
      loginLinkStyledProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref.loginLink, ["text", "url"]);

  return /*#__PURE__*/react.createElement(unsigned_user_state_styles_Container, {
    "data-testid": "stereo-login_menu-unsigned_user_state-container"
  }, messageText && /*#__PURE__*/react.createElement(Message, messageStyledProps, messageText), /*#__PURE__*/react.createElement(StyledLink, (0,esm_extends/* default */.Z)({
    onClick: () => {
      handleUnsignedClick();
    },
    href: loginLinkURL
  }, loginLinkStyledProps), loginLinkText));
};

 false ? 0 : void 0;
UnsignedUserState.defaultProps = {
  message: {},
  loginLink: {},
  handleEventClick: prop_types.func.isRequired
};
/* harmony default export */ var unsigned_user_state = (UnsignedUserState);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/subcomponents/UnsignedUserState/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/subcomponents/SignedUserState/signed-user-state.js




const SignedUserState = ({
  username,
  welcomeMessage,
  logoutMessage,
  signOutUrl,
  menuLinks = [],
  onLogout,
  handleSignedHover,
  handleSignedMenuClick
}) => {
  return /*#__PURE__*/react.createElement(atoms/* Dropdown */.Lt, {
    mouseenter: true,
    pointing: true
  }, /*#__PURE__*/react.createElement(atoms/* Dropdown.Title */.Lt.Title, {
    color: "text.white",
    fill: "background.lighter",
    onMouseEnter: handleSignedHover
  }, welcomeMessage || /*#__PURE__*/react.createElement("span", null, "Ol\xE1, ", /*#__PURE__*/react.createElement("b", null, username))), /*#__PURE__*/react.createElement(atoms/* Dropdown.Menu */.Lt.Menu, {
    pointing: true,
    fontSize: 0,
    p: 2
  }, menuLinks.map(({
    icon,
    label,
    url
  }, i) => /*#__PURE__*/react.createElement(atoms/* Dropdown.Item */.Lt.Item, {
    key: i,
    startIcon: icon,
    p: 1,
    my: 2
  }, /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    onClick: () => handleSignedMenuClick(label),
    href: url,
    fontSize: 0,
    "data-testid": `link-${i}`
  }, label))), /*#__PURE__*/react.createElement(atoms/* Dropdown.Divider */.Lt.Divider, null), /*#__PURE__*/react.createElement(atoms/* Dropdown.Item */.Lt.Item, {
    p: 1,
    my: 2,
    disableHover: true
  }, logoutMessage || `Não é ${username}? `, /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    underline: true,
    px: 0,
    fontSize: 0,
    href: signOutUrl,
    onClick: () => {
      onLogout();
      handleSignedMenuClick('sair');
    },
    "data-testid": "link-logout"
  }, "Sair"))));
};

 false ? 0 : void 0;
SignedUserState.defaultProps = {
  welcomeMessage: '',
  logoutMessage: '',
  signOutUrl: '',
  handleSignedHover: () => {},
  handleSignedMenuClick: () => {}
};
/* harmony default export */ var signed_user_state = (SignedUserState);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/subcomponents/SignedUserState/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/subcomponents/index.js


;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/login-menu.js





/**
 * Styled-system Compatible
 * https://styled-system.com/api
 */

const LoginMenu = ({
  isSignedIn,
  unsignedConfig,
  signedConfig,
  signOutUrl,
  onLogout,
  onUnsignedClick,
  onSignedHover,
  onSignedMenuClick
}) => {
  return /*#__PURE__*/react.createElement(login_menu_styles_Container, null, isSignedIn ? /*#__PURE__*/react.createElement(signed_user_state, (0,esm_extends/* default */.Z)({}, signedConfig, {
    signOutUrl: signOutUrl,
    onLogout: onLogout,
    handleSignedHover: onSignedHover,
    handleSignedMenuClick: onSignedMenuClick
  })) : /*#__PURE__*/react.createElement(unsigned_user_state, (0,esm_extends/* default */.Z)({}, unsignedConfig, {
    handleUnsignedClick: onUnsignedClick
  })));
};

 false ? 0 : void 0;
LoginMenu.defaultProps = {
  isSignedIn: false,
  unsignedConfig: {},
  signedConfig: {},
  onLogout: () => {},
  onUnsignedClick: () => {},
  onSignedHover: () => {},
  onSignedMenuClick: () => {},
  signOutUrl: ''
};
/* harmony default export */ var login_menu = (LoginMenu);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/LoginMenu/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/WishlistCounterButton/wishlist-counter-button.styles.js

const IconContainer = styled_components_browser_esm/* default.div */.ZP.div`
  & > svg {
    transform: scale(1.2);
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/WishlistCounterButton/wishlist-counter-button.js






const WishlistCounterButton = ({
  amount,
  nullable,
  truncateAmountThreshold,
  backgroundColor,
  counterColor = '#db44a7',
  fontColor = '#fff',
  iconColor = '#fff',
  onClick
}) => /*#__PURE__*/react.createElement(atoms/* NumberedButton */.fG, {
  amount,
  nullable,
  truncateAmountThreshold,
  backgroundColor,
  counterColor,
  fontColor,
  onClick
}, /*#__PURE__*/react.createElement(IconContainer, null, /*#__PURE__*/react.createElement(esm/* Heart */.Xdw, {
  color: iconColor
})));

 false ? 0 : void 0;
WishlistCounterButton.defaultProps = {
  amount: 0,
  onClick: () => {},
  nullable: true
};
/* harmony default export */ var wishlist_counter_button = (WishlistCounterButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/WishlistCounterButton/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HorizontalLinks/horizontal-links.styles.js




const LinksList = styled_components_browser_esm/* default.ul */.ZP.ul`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: ${(0,build_esm/* themeGet */.R)('space.3')}px;
  margin-right: 8px;
`;
const LinkItem = styled_components_browser_esm/* default.li */.ZP.li`
  list-style: none;
`; // Apply the same style to header's links and texts

const baseTextAttrs = {
  color: 'text.greyishBlue',
  fontSize: [0, 0, 0, 1],
  fontWeight: ['bold', 'bold', 'bold', 'regular']
};
const horizontal_links_styles_Link = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).attrs(props => Object.assign({
  p: 0
}, baseTextAttrs, props))`
  ${build_esm/* color */.$_}
  ${index_esm/* typography */.cp}
`;
const TextLabel = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs(props => Object.assign({}, baseTextAttrs, props))`
  ${build_esm/* color */.$_}
  ${index_esm/* typography */.cp}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HorizontalLinks/horizontal-links.js




const HorizontalLinks = ({
  data,
  handleHorizontalLinksClick
}) => {
  const {
    linksList = []
  } = data;
  return /*#__PURE__*/react.createElement(LinksList, {
    "data-testid": 'horizontal-links-elem'
  }, linksList.map((link, index) => /*#__PURE__*/react.createElement(LinkItem, {
    key: `link-item-${index}`
  }, link.url ? /*#__PURE__*/react.createElement("div", {
    onClick: () => handleHorizontalLinksClick(link.label)
  }, /*#__PURE__*/react.createElement(horizontal_links_styles_Link, {
    href: link.url
  }, link.label)) : /*#__PURE__*/react.createElement(TextLabel, null, link.label))));
};

HorizontalLinks.defaultProps = {
  data: {
    linksList: []
  },
  handleHorizontalLinksClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var horizontal_links = (HorizontalLinks);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HorizontalLinks/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RadioGroup/index.js + 2 modules
var RadioGroup = __webpack_require__(65055);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SocialShare/index.js + 2 modules
var SocialShare = __webpack_require__(51382);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SubscriptionForm/subscription-form.styles.js




const Form = styled_components_browser_esm/* default.form */.ZP.form``;
Form.Link = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(props => Object.assign({
  color: 'text.lightest'
}, props))`
  ${build_esm/* color */.$_}
`;
Form.Header = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 0
}, props))`
  display: flex;
  align-items: center;

  svg {
    margin-right: ${(0,build_esm/* themeGet */.R)('space.1')}px;
  }

  ${Form.Link} {
    color: ${(0,build_esm/* themeGet */.R)('colors.lightBlue')};
    ${index_esm/* typography */.cp}
  }

  ${build_esm/* color */.$_};
`;
Form.Title = styled_components_browser_esm/* default.h2.attrs */.ZP.h2.attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'medium',
  color: 'text.lightest'
}, props))`
  ${build_esm/* color */.$_}
  ${index_esm/* typography */.cp}
`;
Form.InputWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  p: '1'
}, props))`
  display: flex;
  align-items: center;
  ${index_esm/* space */.Dh}
`;
Form.Input = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Input */.II).attrs(props => Object.assign({
  mr: '2'
}, props))`
  ${index_esm/* space */.Dh}
`;
Form.SubmitBtn = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).attrs(props => Object.assign({
  color: 'secondary',
  size: 'small',
  m: '10px 0'
}, props))``;

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SubscriptionForm/subscription-form.js






const SubscriptionForm = ({
  title,
  policy,
  onSubmitForm
}) => {
  const [name, setName] = (0,react.useState)('');
  const [email, setEmail] = (0,react.useState)('');

  const handleSubmit = (e, onSubmit) => {
    onSubmit(e, {
      name,
      email
    });
  };

  return /*#__PURE__*/react.createElement(Form, {
    "data-testid": "subscription-form-elem",
    onSubmit: e => handleSubmit(e, onSubmitForm)
  }, /*#__PURE__*/react.createElement(Form.Header, null, /*#__PURE__*/react.createElement(esm/* MailOutline */.TbV, {
    "data-testid": "link-icon",
    color: "currentColor",
    width: 25
  }), /*#__PURE__*/react.createElement(Form.Title, null, title), /*#__PURE__*/react.createElement(Form.Link, {
    "data-testid": "link-policy",
    underline: true,
    href: policy == null ? void 0 : policy.url
  }, policy == null ? void 0 : policy.label)), /*#__PURE__*/react.createElement(Form.InputWrapper, null, /*#__PURE__*/react.createElement(HiddenLabel/* default */.Z, {
    text: "digite o seu nome",
    htmlFor: "input-name"
  }), /*#__PURE__*/react.createElement(Form.Input, {
    id: "input-name",
    "data-testid": "input-name",
    placeholder: "digite o seu nome",
    value: name,
    onChange: e => setName(e.target.value)
  }), /*#__PURE__*/react.createElement(HiddenLabel/* default */.Z, {
    text: "digite o seu email",
    htmlFor: "input-email"
  }), /*#__PURE__*/react.createElement(Form.Input, {
    id: "input-email",
    "data-testid": "input-email",
    placeholder: "digite o seu email",
    type: "email",
    value: email,
    onChange: e => setEmail(e.target.value)
  }), /*#__PURE__*/react.createElement(Form.SubmitBtn, {
    "data-testid": "submit-btn",
    disabled: !email || !name,
    type: "submit",
    onClick: e => handleSubmit(e, onSubmitForm)
  }, "Enviar")));
};

 false ? 0 : void 0;
/* harmony default export */ var subscription_form = (SubscriptionForm);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SubscriptionForm/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AddWishlistButton/index.js + 2 modules
var AddWishlistButton = __webpack_require__(38825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeInput/index.js + 2 modules
var ZipcodeInput = __webpack_require__(41237);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeText/index.js + 2 modules
var ZipcodeText = __webpack_require__(1587);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ReviewInput/index.js + 1 modules
var ReviewInput = __webpack_require__(27408);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ProductShipping/product-shipping.styles.js



const ProductShippingCost = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  color: ${(0,build_esm/* getTextColor */.uu)('scratched')};
  text-align: ${({
  textAlign
}) => textAlign};

  span {
    color: ${(0,build_esm/* themeGet */.R)('palette.secondary.dark')};
    font-weight: ${(0,build_esm/* themeGet */.R)('fontWeights.bold')};
  }
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ProductShipping/product-shipping.js





const FreeShipping = () => /*#__PURE__*/react.createElement("span", null, "Frete gr\xE1tis");

function ProductShipping({
  cost,
  displayMode,
  costDescription
}) {
  return /*#__PURE__*/react.createElement(react.Fragment, null, !cost ? null : /*#__PURE__*/react.createElement(ProductShippingCost, {
    "data-testid": "shipping-cost",
    textAlign: displayMode === constants/* MINIATURE */.Co ? 'center' : null
  }, Number(cost) === 0 ? /*#__PURE__*/react.createElement(FreeShipping, null) : costDescription));
}

 false ? 0 : void 0;
/* harmony default export */ var product_shipping = (ProductShipping);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ProductShipping/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/index.js + 2 modules
var MediaReviewCard = __webpack_require__(97949);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TagCoupon/index.js + 2 modules
var TagCoupon = __webpack_require__(62458);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js























































/***/ })

}]);